const LOGIN = '/login';
const FORGOT_PASSWORD = '/forgot-password';
const FORGOT = '/forgot';

const INDEX = '/';

const PROFILE = 'profile';

const DETAIL = 'detail/:id';
const EDIT = 'edit/:id';
const FILE_UPLOAD = 'file-upload/:id';
const INVOICE_UPLOAD = 'invoice-upload/:id';
const REPORT_DOWNLOAD = 'report-download/:id';
const VEHICLE_CHANGE = 'vehicle-change/:id';
const FILES = 'files/:id';
const INTERMEDIATE_TRANSFER_DELIVERY_NOTE = 'intermediate-transfer-delivery-note/:id';
const DELIVERY_NOTE = 'delivery-note/:id/:type';
const ROUTE_CHANGE = 'route-change/:id';
const DATE_CHANGE = 'date-change/:id';
const USER_PERMISSIONS = 'user-permissions/:id';
const ACCEPT_INVITE = 'accept-invite/:id';
const PRINT_A4 = 'print-a4/:id';
const CONTACT_EDIT = 'contact-edit/:id/:regionId';
const RETURN_ROUTE_EDIT = 'return-route-edit/:id';
const COLLECTION_ROUTE_EDIT = 'collection-route-edit/:id';
const DAILY_ROUTE_DRIVER_EDIT = 'daily-route-driver-edit/:id';
const USERS = 'users/:id';

const BULK_EMAIL = 'bulk-email';

const USER = 'user';
const SHIPMENTS = 'shipments';
const ALL_SHIPMENTS = 'all-shipments';
const SEND_EMAIL = 'send-email';
const VENDORS = 'vendors';
const COMPANIES = 'companies';
const COMPANY_CATEGORIES = 'company-categories';
const DAILY_ROUTE = 'daily-route';
const INVOICES = 'invoices';
const INFO = 'info';
const APPLOGIN = 'applogin';
const INVENTORY = 'inventory';
const DEVICEREQUEST = 'device-request';
const DEVICE_STATUS = 'device-status';
const DEVICE_TYPE = 'device-type';
const BRANDS = 'brands';
const MODELS = 'models';
const INVENTORY_LOGS = 'inventory-logs';
const WEIGHBRIDGE = 'weighbridge';
const BARCODE = 'barcode';
const RETURN_BARCODE_CREATE = 'return-barcode-create';
const V2V_BARCODE_CREATE = 'v2v-barcode-create';
const LOST_BARCODE_CREATE = 'lost-barcode-create';
const TRANSFER_AREA = 'transfer-area';
const COUNTRIES = 'countries';
const CITIES = 'cities';
const DISTRICTS = 'districts';
const REPORTS = 'reports';
const PACK_TYPES = 'pack-types';
const VEHICLES = 'vehicles';
const RETURN_SHIPMENTS = 'return-shipments';
const DAMAGED_SHIPMENTS = 'damaged-shipments';
const DESI_CHANGED_PACKAGES = 'desi-changed-packages';
const SUPER_ADMIN_HISTORY = 'super-admin-history';
const PACKAGE_DESI_CHANGE_REPORT = 'package-desi-change-report';
const PACKAGE_CONTROL = 'package-control';
const PACKAGE_CONTROL_REPORT = 'package-control-report';
const SUPER_ADMIN_HISTORY_REPORT = 'super-admin-history-report';
const VEHICLE_CATEGORY = 'vehicle-category';
const VEHICLE_PLANING = 'vehicle-planing';
const VEHICLE_REQUEST = 'vehicle-request';
const PACKAGE_REQUEST = 'package-request';
const DESI_ADET_KONTROL = 'firma-desi-adet-kontrol';
const DESI_ADET_KONTROL_LOGS = 'desi-adet-kontrol-loglari';
const EXCEL_PACKAGE_PRICE_UPDATE = 'excel-paket-fiyat-guncelle';
const SUPPLIERS = 'suppliers';
const WAREHOUSE_VEHICLE_ENTRANCE = 'warehouse-vehicle-entrance';
const DEPOT_LAYOUT = 'depo-semasi';
const RAMP_ASSIGNMENT = 'rampa-atama';
const RAMP_OCCUPANCY = 'rampa-arac-giris';
const RAMP_ANALYTICS = 'rampa-analitik';
const DEMAND_FORECAST = 'talep-tahmini';
const DEMAND_FORECAST_ACCURACY = 'talep-tahmini/dogruluk';
const DEMAND_FORECAST_METHODOLOGY = 'talep-tahmini/mantik';
const RAMP_BOARD = 'rampa-panosu';
const PLAKA_OKUMA = 'guvenlik/plaka-okuma';
const PURCHASE_ORDERS = 'satin-alma-siparisleri';
const PURCHASE_REQUESTS = 'satin-alma-talepleri';
const PURCHASING_APPROVALS = 'onay-bekleyenler';
const PURCHASING_RFQS = 'teklif-surecleri';
const PURCHASING_WORKFLOWS = 'onay-akislari';
const DIA_SUPPLIERS = 'dia-tedarikciler';
const DIA_API_LOGS = 'dia-api-cagrilari';
const DIA_DURUM = 'dia-durum';
const GOODS_RECEIPTS = 'mal-kabul';
const PURCHASING_ANALYTICS = 'satin-alma-analitik';
const PURCHASING_REPORTS = 'satin-alma-raporlari';
const INVOICE_MATCHING = 'fatura-eslestirme';
const EFATURA_ARCHIVE = 'e-fatura-arsivi';
const PURCHASING_DEFINITIONS = 'satin-alma-tanimlari';
const PURCHASING_ROLES = 'satin-alma-yetkileri';
const PURCHASING_ORG = 'satin-alma-organizasyonu';
const PURCHASING_CUSTOM_FIELDS = 'satin-alma-ozel-alanlar';
const PURCHASING_GUIDE = 'satin-alma-surec-rehberi';
const CREATE_MICRO_ROUTE = 'create-micro-route';
const REGION = 'region';
const CREATE_COMPANY_ROUTE = 'create-company-route';
const MICRO_ROUTE_TRANSPORTATION = 'micro-route-transportation';
const REGION_MICRO_TRANSPORTATION = 'region-micro-transportation';
const PROVINCE_ROUTE_TRANSPORTATION = 'province-route-transportation';
const DISTRICT_ROUTE_TRANSPORTATION = 'district-route-transportation';
const CONTAINERS = 'containers';
const PERSONEL = 'personel';
const PERSONEL_ENTRANCE_EXIT = 'personel-entrance-exit';
const PERSONEL_SUPPLIER = 'personel-supplier';
const SHIFTS = 'shifts';
const DOOR = 'door';
const MISSION = 'mission';
const LOST_PACKAGES = 'lost-packages';
const CITY_DISTRICT_ROUTE_EDIT = 'city-district-route-edit';
const MANUEL_BARCODE_PRINT = 'manuel-barcode-print';
const APPS = 'apps';
const PERSONEL_LOG = 'personel-log';
const FORD_INTEGRATION_TRIGGER = 'ford-integration-trigger';
const ROUTE = 'route';
const SHIPMENT_DELIVERY = 'shipment-delivery';
const DOCUMENT = 'document';
const INTER_DEALER_SHIPMENT = 'inter-dealer-shipment';
const USER_INVITE = 'user-invite';
const INVITE_CREATE_USER = 'invite-create-user/:id';
const LOGIN_CLOUDFLARE = 'login/cloudflare';
const AGREEMENTS = 'agreements';
const INVITED_USERS = 'invited-users';
const WEBHOOKS = 'webhooks';
const BULK_PRINTING = 'bulk-printing';
const OLD_RETURN_PACKAGE = 'old-return-package';
const COMPANY_DAILY_VOLUME = 'company-daily-volume';
const COMPANY_UNLOADED_VOLUME = 'company-unloaded-volume';
const BULKCHANGE_USERS = 'bulkchange-users';
const ROUTE_DAILY_VOLUME = 'route-daily-volume';
const CSV_VENDOR_CREATE = 'csv-vendor-create';
const CSV_INVENTORY_CREATE = 'csv-inventory-create';
const XDOCKS_DAILY_VOLUME = 'xdocks-daily-volume';
const XDOCK_DAILY_OPERATIONS = 'xdock-daily-operations';
const XDOCK_DAILY_OPERATIONS_HISTORY = 'xdock-daily-operations-history';
const TRANSFER_AUDIT = 'transfer-audit';
// Bölge Araç Yoklaması + Bölge Araç Ataması (plan: docs/BOLGE_ARAC_YOKLAMA_PLANI.md v1.3)
const XDOCK_VEHICLE_ATTENDANCE = 'xdock-vehicle-attendance';
const XDOCK_REGION_ALERTS = 'xdock-region-alerts';
const VEHICLE_REGION_ASSIGNMENTS = 'vehicle-region-assignments';
const VEHICLE_REGION_AREAS = 'vehicle-region-areas';
const ROUTE_CACHE = 'route-cache';
const CUSTOMER_FORM = 'customer-form';
// YPN /destek formu talepleri (CMS) — cityapi e-postasındaki link bu yolu kullanır
const SUPPORT_REQUESTS = 'support-requests';
const CALL_FORWARDING = 'call-forwarding';
const ROUTE_SESSION = 'route-session';
const ROUTE_SESSION_SPECIAL = 'route-session-special';
const ROUTE_SESSION_FILE_CHECK = 'route-session-file-check';
const PLATE_EVENTS_REPORT = 'plaka-okuma';
const INDEX_ROUTE_SESSIONS_OLUSTURULDU = 'index-route-sessions-olusturuldu';
const MONTHLY_COMPANY_REPORT = 'monthly-company-report';
const WEEKLY_COMPANY_REPORT = 'weekly-company-report';
const DAILY_COMPANY_REPORT = 'daily-company-report';
const CUSTOMER_VISITS = 'customer-visits';
const PANEL_NOTIFICATIONS = 'panel-notifications';
const PACKAGE_TANZIM = 'package-tanzim';
const DEALER_GROUPS = 'dealer-groups';
const VEHICLE_TRACKING = 'vehicle-tracking';
const COMPANY_MONITORING = 'company-monitoring';
const MY_NOTIFICATIONS = 'my-notifications';
// Organizasyon & Bildirim Takımları (plan: docs/BILDIRIM_TAKIMLARI_PLANI.md §7.1; FE rota yolları, API yolları değil)
const ORG_TITLES = 'org/titles';
const ORG_STRUCTURE = 'org/structure';
const NOTIFICATION_TOPICS = 'notification-routing/topics';
const NOTIFICATION_HISTORY = 'notification-routing/history';
const ORG_CHANGE_LOGS = 'org/change-logs';
const COMPANY_EXIT = 'company-exit';
const TRANSFER_VEHICLE_ENTRANCE = 'transfer-vehicle-entrance';
const REGION_TRANSFER_TYPES = 'region-transfer-types';
const ROUTE_SESSION_STATISTICS = 'route-session-statistics';
const VEHICLES_REPORT = 'vehicles-report';
const TRANSFER_VEHICLE_ENTRY_REPORT = 'transfer-vehicle-entry-report';
const TRANSFER_ROUTE_REPORT = 'transfer-route-report';
const VEHICLE_REQUEST_REPORT = 'vehicle-request-report';
const FULL_TRUCK_LOAD = 'full-truck-load';
const DELIVERY_TIMES = 'delivery-times';
const PUBLIC_HOLIDAYS = 'public-holidays';
const TRANSFER_ROUTE_TIMES = 'transfer-route-times';
const CURRENT_ROUTE_PLAN = 'current-route-plan';
const CHAT_MESSAGES_LIST = 'chat-messages-list';
const CONVERSATIONS = 'conversations';
const CAREER_FORM = 'career-form';
const OPEN_POSITIONS = 'open-positions';
const DISTRIBUTION_EXPEDITIONS = 'distribution-expeditions';
const MOBILIZ_VEHICLE_DETAIL = 'mobiliz-vehicle-detail';
const MOBILIZ_FLEET = 'mobiliz-fleet';
const ETABLOLAR = 'etablolar';
const DELIVERY_CALCULATION = 'delivery-calculation';
const DELIVERY_CALCULATION_REGION = 'delivery-calculation-region';
const SALES_CRM = 'sales-crm';
const SALES_CRM_LEADS = 'sales-crm/leads';
const SALES_CRM_AGENDA = 'sales-crm/agenda';
const SALES_CRM_QUOTES = 'sales-crm/quotes';
const SALES_CRM_REPORTS = 'sales-crm/reports';
const SALES_CRM_SETTINGS = 'sales-crm/settings';
const DELIVERY_REPORT = 'delivery-report';
const DESKTOP_REPORT_USERS = 'desktop-report-users';
const COMPANIES_DETAIL_REPORT = 'companies-detail-report';
const VENDORS_DETAIL_REPORT = 'vendors-detail-report';
const DISTRIBUTION_EXPEDITIONS_REPORT = 'distribution-expeditions-report';
const POINT_DISTRICTS = 'point-districts';
const SAVED_REPORTS = 'saved-reports';
const NEIGHBOURHOODS = 'neighbourhoods';
const TICKETS = 'tickets';
const TICKET_TEAMS = 'tickets/teams';
const TICKET_STATISTICS = 'tickets/statistics';
const FEEDBACK = 'feedback';
const FEEDBACK_ADMIN = 'admin/feedback';
const ACTIVITIES = 'activities';
const BARCODE_ALERTS = 'barcode-alerts';
const DEVICE_DIAGNOSTICS = 'device-diagnostics';
const REPLAY = 'replay';
const AGREEMENT_LOGS = 'agreement-logs';
const COMPANY_LOGS = 'company-logs';
const VENDOR_LOGS = 'vendor-logs';
const POINT_LOGS = 'point-logs';
const POINT_MAP_LOGS = 'point-map-logs';
const POINT_MAP_ADMIN = 'point-map-admin';
// Filo modülü (plan: docs/FILO_MODULU_PLANI.md) — yalnız ADMIN/SUPERADMIN
const FLEET_DASHBOARD = 'filo';
const FLEET_VEHICLES = 'filo/araclar';
const FLEET_VEHICLE_DETAIL = 'filo/araclar/:id';
const FLEET_VEHICLE_EDIT = 'filo/araclar/:id/duzenle';
const FLEET_DRIVERS = 'filo/suruculer';
const FLEET_DRIVER_DETAIL = 'filo/suruculer/:id';
const FLEET_ASSIGNMENTS = 'filo/zimmetler';
const FLEET_DOCUMENTS = 'filo/belgeler';
const FLEET_AGENDA = 'filo/ajanda';
const FLEET_NOTIFICATIONS = 'filo/bildirimler';
const FLEET_MAP = 'filo/harita';
const FLEET_WORK_ORDERS = 'filo/bakim';
const FLEET_WORK_ORDER_DETAIL = 'filo/bakim/:id';
const FLEET_PLANS = 'filo/bakim-planlari';
const FLEET_TIRES = 'filo/lastikler';
const FLEET_INSPECTIONS = 'filo/muayeneler';
const FLEET_POLICIES = 'filo/policeler';
const FLEET_OFFERS = 'filo/teklifler';
const FLEET_DAMAGES = 'filo/hasarlar';
const FLEET_DAMAGE_DETAIL = 'filo/hasarlar/:id';
const FLEET_TOLLS = 'filo/hgs';
const FLEET_FINES = 'filo/cezalar';
const FLEET_EXPENSES = 'filo/giderler';
const FLEET_BUDGETS = 'filo/butceler';
const FLEET_TCO = 'filo/tco';
const FLEET_REPORTS = 'filo/raporlar';
const FLEET_SUPPLIERS = 'filo/tedarikciler';
const FLEET_CONTRACTS = 'filo/sozlesmeler';
const FLEET_TIMESHEET = 'filo/puantaj';
const FLEET_SCORING = 'filo/surucu-degerlendirme';
const FLEET_SCORING_DETAIL = 'filo/surucu-degerlendirme/:id';
const FLEET_INDICATORS = 'filo/gostergeler';
const FLEET_SCHEMES = 'filo/skor-semalari';
const FLEET_OPTION_SETS = 'filo/tanimlar/secim-listeleri';
const FLEET_CUSTOM_FIELDS = 'filo/tanimlar/ozel-alanlar';
const FLEET_AUTOMATIONS = 'filo/tanimlar/otomasyonlar';
const FLEET_REMINDER_SETTINGS = 'filo/tanimlar/hatirlatma';
const FLEET_AUDIT = 'filo/tanimlar/denetim';
// Taşıyıcı olma talepleri (yedekparcamnerede.com/tasiyici) — CityAPI e-posta bağlantısı bu yolu kullanır
const FLEET_CARRIER_REQUESTS = 'filo/tasiyici-talepleri';
const FLEET_CARRIER_REQUEST_DETAIL = 'filo/tasiyici-talepleri/:id';
const VEHICLE_LOGS = 'vehicle-logs';
const ROUTE_LOGS = 'route-logs';
const ROUTE_SESSION_LOGS = 'route-session-logs';
const TRANSFER_VEHICLE_ENTRY_LOGS = 'transfer-vehicle-entry-logs';
const VEHICLE_PLAN_LOGS = 'vehicle-plan-logs';
const USER_LOGS = 'user-logs';
const ZERO_DESI_UPDATE = 'zero-desi-update';
const OLUSTURULDU_ISLEMLERI = 'olusturuldu-islemleri';
const ZERO_DESI_LOGS = 'zero-desi-logs';
const ONE_DESI_REPORT = 'one-desi-report';
const SCAN_ZERO_DESI = 'scan-zero-desi';
const COMPANY_DESI_RANGES = 'company-desi-ranges';
const DOCUMENT_LOGS = 'document-logs';
const MULTI_SESSION_USERS = 'multi-session-users';
const SESSION_INVALIDATION_LOGS = 'session-invalidation-logs';
const AUDIT_LOGS = 'audit-logs';
const MCP_AUDIT = 'mcp-denetim';
const OKUTMA_TESHIS = 'okutma-teshis';
const SANTRAL_API = 'santral-api';
const INSURER_ACCESS = 'sigorta-erisim';
const INSURER_ACCESS_GRANT = 'izin/:id';
const INSURER_ACCESS_GRANT_DETAIL = 'izin/:id/detay';
const INSURERS = 'sigorta-sirketleri';
const INSURER_ACCESS_INSURER = 'sirket/:id';
const DELIVERY_TIME_LOGS = 'delivery-time-logs';
const PRICE_ESTIMATE_LOGS = 'fiyat-hesaplama-loglari';
const DEDIKE_NAKLIYE = 'dedike-nakliye';
const HARICI_KARGO = 'harici-kargo';
const ZAIMBOT = 'zaimbot';
const AGENTZAIM = 'agentzaim';
const SPECIAL_VEHICLE_SUGGESTIONS = 'special-vehicle-suggestions';
const CUSTOMER_TRACKING = 'customer-tracking';
const CUSTOMER_TRACKING_ALERTS = 'customer-tracking-alerts';
const UNDELIVERED_PACKAGES = 'undelivered-packages';
const UNDELIVERED_PACKAGES_LOGS = 'undelivered-packages-logs';
const BULK_RECALC_ROUTE = 'bulk-recalc-route';
const BULK_CALC_PRICE = 'bulk-calc-price';
const CHECKLIST = 'checklist';
const CHECKLIST_TASKS = 'checklist/tasks';
const CHECKLIST_REPORT = 'checklist/report';
const UNIT_DESI_AVERAGES = 'unit-desi-averages';
const COMPANY_VEHICLE_VISITS = 'company-vehicle-visits';
const LOW_VOLUME_COMPANIES = 'low-volume-companies';
const EXTERNAL_CARGO_TRACKING = 'external-cargo-tracking';
const REMOTE_ACCESS = 'remote-access';
const REMOTE_ACCESS_SESSION = 'remote-access/session/:id';
const LIVE_MONITOR = 'live-monitor';
const CARGO_IN_WAREHOUSE = 'cargo-in-warehouse';
const CARGO_IN_WAREHOUSE_LOGS = 'cargo-in-warehouse-logs';
const DIA_CARI_SYNC = 'dia-cari-sync';
const DIA_SYNC_HISTORY = 'dia-sync-history';
const DIA_UNMATCHED = 'dia-unmatched';
const DIA_CARI_KARTLAR = 'dia-cari-kartlar';
const DIA_IRSALIYE_AKTAR = 'dia-irsaliye-aktar';
const DIA_IRSALIYE_AYARLAR = 'dia-irsaliye/ayarlar';
const DIA_IRSALIYE_OLUSTUR = 'dia-irsaliye/olustur';
const FUEL = 'fuel';
const FUEL_STATIONS = 'fuel-stations';

export const ROUTES = {
  INDEX: { PATH: INDEX },
  LOGIN: { PATH: LOGIN },
  FORGOT_PASSWORD: { PATH: FORGOT_PASSWORD },
  FORGOT: { PATH: FORGOT },
  LOGIN_CLOUDFLARE: { PATH: LOGIN_CLOUDFLARE },
  ACCEPT_INVITE: { PATH: ACCEPT_INVITE },
  INVITE_CREATE_USER: {
    PATH: INVITE_CREATE_USER
  },
  PROFILE: { PATH: PROFILE },
  APPLOGIN: { PATH: APPLOGIN },
  SHIPMENTS: {
    PATH: SHIPMENTS,
    DETAIL: { PATH: `${SHIPMENTS}/${DETAIL}` },
    EDIT: { PATH: EDIT }
  },
  SHIPMENT_DELIVERY: {
    PATH: SHIPMENT_DELIVERY
  },
  INTER_DEALER_SHIPMENT: {
    PATH: INTER_DEALER_SHIPMENT
  },
  USER: {
    PATH: USER,
    DETAIL: { PATH: DETAIL },
    EDIT: { PATH: EDIT },
    USER_PERMISSIONS: { PATH: USER_PERMISSIONS },
    USER_INVITE: { PATH: USER_INVITE }
  },
  INVITED_USERS: {
    PATH: INVITED_USERS
  },
  VENDORS: {
    PATH: VENDORS,
    DETAIL: { PATH: `${VENDORS}/${DETAIL}` },
    EDIT: { PATH: EDIT },
    ROUTE_CHANGE: { PATH: ROUTE_CHANGE },
    DATE_CHANGE: { PATH: DATE_CHANGE }
  },
  COMPANIES: {
    PATH: COMPANIES,
    EDIT: { PATH: EDIT },
    ROUTE_CHANGE: { PATH: ROUTE_CHANGE },
    DETAIL: { PATH: `${COMPANIES}/${DETAIL}` },
    RETURN_ROUTE_EDIT: { PATH: RETURN_ROUTE_EDIT },
    COLLECTION_ROUTE_EDIT: { PATH: COLLECTION_ROUTE_EDIT },
    USERS: { PATH: USERS }
  },
  COMPANY_CATEGORIES: {
    PATH: COMPANY_CATEGORIES,
    EDIT: { PATH: EDIT }
  },
  DAILY_ROUTE: {
    PATH: DAILY_ROUTE,
    EDIT: { PATH: EDIT },
    FILE_UPLOAD: { PATH: FILE_UPLOAD },
    INVOICE_UPLOAD: { PATH: INVOICE_UPLOAD },
    REPORT_DOWNLOAD: { PATH: REPORT_DOWNLOAD },
    DETAIL: { PATH: `${DAILY_ROUTE}/${DETAIL}` },
    VEHICLE_CHANGE: { PATH: VEHICLE_CHANGE },
    FILES: { PATH: FILES },
    INTERMEDIATE_TRANSFER_DELIVERY_NOTE: { PATH: INTERMEDIATE_TRANSFER_DELIVERY_NOTE },
    DELIVERY_NOTE: { PATH: DELIVERY_NOTE },
    PRINT_A4: { PATH: `${DAILY_ROUTE}/${PRINT_A4}` },
    DAILY_ROUTE_DRIVER_EDIT: { PATH: DAILY_ROUTE_DRIVER_EDIT }
  },
  INVOICES: {
    PATH: INVOICES
  },
  INFO: {
    PATH: INFO
  },
  INVENTORY: {
    PATH: INVENTORY,
    EDIT: { PATH: `${INVENTORY}/${EDIT}` },
    DETAIL: { PATH: `${INVENTORY}/${DETAIL}` }
  },
  DEVICEREQUEST: {
    PATH: DEVICEREQUEST,
    EDIT: { PATH: `${DEVICEREQUEST}/${EDIT}` }
  },
  DEVICE_STATUS: {
    PATH: DEVICE_STATUS,
    EDIT: { PATH: `${DEVICE_STATUS}/${EDIT}` }
  },
  DEVICE_TYPE: {
    PATH: DEVICE_TYPE,
    EDIT: { PATH: `${DEVICE_TYPE}/${EDIT}` }
  },
  BRANDS: {
    PATH: BRANDS,
    EDIT: { PATH: `${BRANDS}/${EDIT}` }
  },
  MODELS: {
    PATH: MODELS,
    EDIT: { PATH: `${MODELS}/${EDIT}` }
  },
  INVENTORY_LOGS: {
    PATH: INVENTORY_LOGS,
    DETAIL: { PATH: `${INVENTORY_LOGS}/${DETAIL}` }
  },
  WEIGHBRIDGE: {
    PATH: WEIGHBRIDGE
  },
  BARCODE: {
    PATH: BARCODE,
    EDIT: { PATH: `${BARCODE}/${EDIT}` },
    RETURN_BARCODE_CREATE: { PATH: `${BARCODE}/${RETURN_BARCODE_CREATE}` },
    V2V_BARCODE_CREATE: { PATH: `${BARCODE}/${V2V_BARCODE_CREATE}` },
    LOST_BARCODE_CREATE: { PATH: `${BARCODE}/${LOST_BARCODE_CREATE}` }
  },
  TRANSFER_AREA: {
    PATH: TRANSFER_AREA
  },
  COUNTRIES: {
    PATH: COUNTRIES,
    EDIT: { PATH: EDIT }
  },
  CITIES: {
    PATH: CITIES,
    EDIT: { PATH: EDIT }
  },
  DISTRICTS: {
    PATH: DISTRICTS,
    EDIT: { PATH: EDIT }
  },
  REPORTS: {
    SHIPMENTS: { PATH: `${REPORTS}/${SHIPMENTS}` },
    PERSONEL_LOG: { PATH: `${REPORTS}/${PERSONEL_LOG}` },
    VEHICLE_PLANING: { PATH: `${REPORTS}/${VEHICLE_PLANING}` },
    RETURN_SHIPMENTS: { PATH: `${REPORTS}/${RETURN_SHIPMENTS}` },
    DAMAGE_SHIPMENTS: { PATH: `${REPORTS}/${DAMAGED_SHIPMENTS}` },
    INTER_DEALER_SHIPMENT: { PATH: `${REPORTS}/${INTER_DEALER_SHIPMENT}` },
    BY_ID: { PATH: `${REPORTS}/:id` },
    ALL_SHIPMENTS: { PATH: `${REPORTS}/${ALL_SHIPMENTS}` },
    LOST_PACKAGES: { PATH: `${REPORTS}/${LOST_PACKAGES}` },
    CALL_FORWARDING: { PATH: `${REPORTS}/${CALL_FORWARDING}` },
    ROUTE_SESSION: { PATH: `${REPORTS}/${ROUTE_SESSION}` },
    ROUTE_SESSION_SPECIAL: { PATH: `${REPORTS}/${ROUTE_SESSION_SPECIAL}` },
    ROUTE_SESSION_FILE_CHECK: { PATH: `${REPORTS}/${ROUTE_SESSION_FILE_CHECK}` },
    PLATE_EVENTS: { PATH: `${REPORTS}/${PLATE_EVENTS_REPORT}` },
    INDEX_ROUTE_SESSIONS_OLUSTURULDU: { PATH: `${REPORTS}/${INDEX_ROUTE_SESSIONS_OLUSTURULDU}` },
    MONTHLY_COMPANY_REPORT: { PATH: `${REPORTS}/${MONTHLY_COMPANY_REPORT}` },
    WEEKLY_COMPANY_REPORT: { PATH: `${REPORTS}/${WEEKLY_COMPANY_REPORT}` },
    DAILY_COMPANY_REPORT: { PATH: `${REPORTS}/${DAILY_COMPANY_REPORT}` },
    PACKAGE_DESI_CHANGE_REPORT: { PATH: `${REPORTS}/${PACKAGE_DESI_CHANGE_REPORT}` },
    PACKAGE_CONTROL_REPORT: { PATH: `${REPORTS}/${PACKAGE_CONTROL_REPORT}` },
    SUPER_ADMIN_HISTORY_REPORT: { PATH: `${REPORTS}/${SUPER_ADMIN_HISTORY_REPORT}` },
    VEHICLES: { PATH: `${REPORTS}/${VEHICLES_REPORT}` },
    TRANSFER_VEHICLE_ENTRY: { PATH: `${REPORTS}/${TRANSFER_VEHICLE_ENTRY_REPORT}` },
    TRANSFER_ROUTE_REPORT: { PATH: `${REPORTS}/${TRANSFER_ROUTE_REPORT}` },
    COMPANIES_DETAIL_REPORT: { PATH: `${REPORTS}/${COMPANIES_DETAIL_REPORT}` },
    VENDORS_DETAIL_REPORT: { PATH: `${REPORTS}/${VENDORS_DETAIL_REPORT}` },
    VEHICLE_REQUEST_REPORT: { PATH: `${REPORTS}/${VEHICLE_REQUEST_REPORT}` },
    CARGO_IN_WAREHOUSE_REPORT: { PATH: `${REPORTS}/cargo-in-warehouse-report` },
    DISTRIBUTION_EXPEDITIONS_REPORT: { PATH: `${REPORTS}/${DISTRIBUTION_EXPEDITIONS_REPORT}` }
  },
  PACK_TYPES: {
    PATH: PACK_TYPES,
    EDIT: { PATH: EDIT }
  },
  PACKAGE_CONTROL: {
    PATH: PACKAGE_CONTROL,
    DETAIL: { PATH: `${PACKAGE_CONTROL}/${DETAIL}` }
  },
  VEHICLES: {
    PATH: VEHICLES,
    EDIT: { PATH: EDIT }
  },
  SEND_EMAIL: {
    PATH: SEND_EMAIL,
    EDIT: { PATH: `${SEND_EMAIL}/${EDIT}` }
  },
  BULK_EMAIL: {
    PATH: BULK_EMAIL,
    NEW: { PATH: `${BULK_EMAIL}/new` },
    DETAIL: { PATH: `${BULK_EMAIL}/${DETAIL}` }
  },
  RETURN_SHIPMENTS: {
    PATH: RETURN_SHIPMENTS
  },
  DAMAGED_SHIPMENTS: {
    PATH: DAMAGED_SHIPMENTS
  },
  DESI_CHANGED_PACKAGES: {
    PATH: DESI_CHANGED_PACKAGES
  },
  SUPER_ADMIN_HISTORY: {
    PATH: SUPER_ADMIN_HISTORY,
    DETAIL: { PATH: `${SUPER_ADMIN_HISTORY}/${DETAIL}` }
  },
  VEHICLE_CATEGORY: {
    PATH: VEHICLE_CATEGORY,
    EDIT: { PATH: EDIT }
  },
  VEHICLE_PLANING: {
    PATH: VEHICLE_PLANING,
    EDIT: { PATH: EDIT }
  },
  VEHICLE_REQUEST: {
    PATH: VEHICLE_REQUEST,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${VEHICLE_REQUEST}/${DETAIL}` }
  },
  PACKAGE_REQUEST: {
    PATH: PACKAGE_REQUEST,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${PACKAGE_REQUEST}/${DETAIL}` }
  },
  DESI_ADET_KONTROL: {
    PATH: DESI_ADET_KONTROL,
    CREATE: { PATH: `${DESI_ADET_KONTROL}/new` },
    DETAIL: { PATH: `${DESI_ADET_KONTROL}/${DETAIL}` }
  },
  DESI_ADET_KONTROL_LOGS: {
    PATH: DESI_ADET_KONTROL_LOGS
  },
  EXCEL_PACKAGE_PRICE_UPDATE: {
    PATH: EXCEL_PACKAGE_PRICE_UPDATE
  },
  SUPPLIERS: {
    PATH: SUPPLIERS,
    EDIT: { PATH: EDIT }
  },
  WAREHOUSE_VEHICLE_ENTRANCE: {
    PATH: WAREHOUSE_VEHICLE_ENTRANCE
  },
  DEPOT_LAYOUT: {
    PATH: DEPOT_LAYOUT
  },
  RAMP_ASSIGNMENT: {
    PATH: RAMP_ASSIGNMENT
  },
  RAMP_OCCUPANCY: {
    PATH: RAMP_OCCUPANCY
  },
  RAMP_ANALYTICS: {
    PATH: RAMP_ANALYTICS
  },
  DEMAND_FORECAST: {
    PATH: DEMAND_FORECAST
  },
  DEMAND_FORECAST_ACCURACY: {
    PATH: DEMAND_FORECAST_ACCURACY
  },
  DEMAND_FORECAST_METHODOLOGY: {
    PATH: DEMAND_FORECAST_METHODOLOGY
  },
  RAMP_BOARD: {
    PATH: RAMP_BOARD
  },
  PLAKA_OKUMA: {
    PATH: PLAKA_OKUMA
  },
  PURCHASE_ORDERS: {
    PATH: PURCHASE_ORDERS,
    EDIT: { PATH: EDIT }
  },
  PURCHASE_REQUESTS: {
    PATH: PURCHASE_REQUESTS,
    EDIT: { PATH: EDIT }
  },
  PURCHASING_APPROVALS: {
    PATH: PURCHASING_APPROVALS
  },
  PURCHASING_RFQS: {
    PATH: PURCHASING_RFQS,
    EDIT: { PATH: EDIT }
  },
  PURCHASING_WORKFLOWS: {
    PATH: PURCHASING_WORKFLOWS
  },
  DIA_SUPPLIERS: {
    PATH: DIA_SUPPLIERS
  },
  DIA_API_LOGS: {
    PATH: DIA_API_LOGS
  },
  DIA_DURUM: {
    PATH: DIA_DURUM
  },
  GOODS_RECEIPTS: {
    PATH: GOODS_RECEIPTS
  },
  PURCHASING_ANALYTICS: {
    PATH: PURCHASING_ANALYTICS
  },
  PURCHASING_REPORTS: {
    PATH: PURCHASING_REPORTS
  },
  INVOICE_MATCHING: {
    PATH: INVOICE_MATCHING
  },
  EFATURA_ARCHIVE: {
    PATH: EFATURA_ARCHIVE,
    DETAIL: {
      PATH: `${EFATURA_ARCHIVE}/${DETAIL}`
    }
  },
  PURCHASING_DEFINITIONS: {
    PATH: PURCHASING_DEFINITIONS
  },
  PURCHASING_ROLES: {
    PATH: PURCHASING_ROLES
  },
  PURCHASING_ORG: {
    PATH: PURCHASING_ORG
  },
  PURCHASING_CUSTOM_FIELDS: {
    PATH: PURCHASING_CUSTOM_FIELDS
  },
  PURCHASING_GUIDE: {
    PATH: PURCHASING_GUIDE
  },
  CREATE_MICRO_ROUTE: {
    PATH: CREATE_MICRO_ROUTE,
    EDIT: { PATH: EDIT }
  },
  ROUTE: {
    PATH: ROUTE,
    EDIT: { PATH: EDIT }
  },
  REGION: {
    PATH: REGION,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${REGION}/${DETAIL}` },
    CONTACT_EDIT: { PATH: CONTACT_EDIT }
  },
  CREATE_COMPANY_ROUTE: {
    PATH: CREATE_COMPANY_ROUTE,
    EDIT: { PATH: EDIT }
  },
  MICRO_ROUTE_TRANSPORTATION: {
    PATH: MICRO_ROUTE_TRANSPORTATION,
    EDIT: { PATH: EDIT }
  },
  REGION_MICRO_TRANSPORTATION: {
    PATH: REGION_MICRO_TRANSPORTATION,
    EDIT: { PATH: EDIT }
  },
  PROVINCE_ROUTE_TRANSPORTATION: {
    PATH: PROVINCE_ROUTE_TRANSPORTATION,
    EDIT: { PATH: EDIT }
  },
  DISTRICT_ROUTE_TRANSPORTATION: {
    PATH: DISTRICT_ROUTE_TRANSPORTATION,
    EDIT: { PATH: EDIT }
  },
  CONTAINERS: {
    PATH: CONTAINERS,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${CONTAINERS}/${DETAIL}` }
  },
  PERSONEL: {
    PATH: PERSONEL,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${PERSONEL}/${DETAIL}` }
  },
  PERSONEL_ENTRANCE_EXIT: {
    PATH: PERSONEL_ENTRANCE_EXIT,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${PERSONEL_ENTRANCE_EXIT}/${DETAIL}` }
  },
  PERSONEL_SUPPLIER: {
    PATH: PERSONEL_SUPPLIER,
    EDIT: { PATH: EDIT }
  },
  SHIFTS: {
    PATH: SHIFTS,
    EDIT: { PATH: EDIT }
  },
  MISSION: {
    PATH: MISSION,
    EDIT: { PATH: EDIT }
  },
  DOOR: {
    PATH: DOOR,
    EDIT: { PATH: EDIT }
  },
  LOST_PACKAGES: {
    PATH: LOST_PACKAGES,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: `${LOST_PACKAGES}/${DETAIL}` },
    LOSS_BARCODE_CREATE: { PATH: `${LOST_PACKAGES}/loss-barcode-create` },
    HELP: { PATH: `${LOST_PACKAGES}/help` },
    /** Hesapsız belge yükleme (talep mailindeki token'lı link) — giriş gerekmez */
    RESPOND: { PATH: `${LOST_PACKAGES}/respond/:token` }
  },
  CITY_DISTRICT_ROUTE_EDIT: {
    PATH: CITY_DISTRICT_ROUTE_EDIT,
    EDIT: { PATH: EDIT }
  },
  MANUEL_BARCODE_PRINT: {
    PATH: MANUEL_BARCODE_PRINT
  },
  APPS: {
    PATH: APPS,
    DETAIL: { PATH: DETAIL },
    EDIT: { PATH: EDIT }
  },
  FORD_INTEGRATION_TRIGGER: {
    PATH: FORD_INTEGRATION_TRIGGER
  },
  COMPANY_EXIT: {
    PATH: COMPANY_EXIT
  },
  DOCUMENT: {
    PATH: DOCUMENT,
    EDIT: { PATH: EDIT }
  },
  AGREEMENTS: {
    PATH: AGREEMENTS,
    EDIT: { PATH: `${AGREEMENTS}/${EDIT}` }
  },
  WEBHOOKS: {
    PATH: WEBHOOKS,
    EDIT: { PATH: EDIT }
  },
  BULK_PRINTING: {
    RETURN_SHIPMENTS: { PATH: `${BULK_PRINTING}/${RETURN_SHIPMENTS}` },
    SHIPMENTS: { PATH: `${BULK_PRINTING}/${SHIPMENTS}` },
    INTER_DEALER_SHIPMENT: { PATH: `${BULK_PRINTING}/${INTER_DEALER_SHIPMENT}` }
  },
  OLD_RETURN_PACKAGE: {
    PATH: OLD_RETURN_PACKAGE
  },
  COMPANY_DAILY_VOLUME: {
    PATH: COMPANY_DAILY_VOLUME
  },
  ROUTE_DAILY_VOLUME: {
    PATH: ROUTE_DAILY_VOLUME
  },
  BULKCHANGE_USERS: {
    PATH: BULKCHANGE_USERS
  },
  CSV_VENDOR_CREATE: {
    PATH: CSV_VENDOR_CREATE
  },
  CSV_INVENTORY_CREATE: {
    PATH: CSV_INVENTORY_CREATE
  },
  XDOCKS_DAILY_VOLUME: {
    PATH: XDOCKS_DAILY_VOLUME,
    DETAIL: { PATH: DETAIL }
  },
  XDOCK_DAILY_OPERATIONS: {
    PATH: XDOCK_DAILY_OPERATIONS
  },
  TRANSFER_AUDIT: {
    PATH: TRANSFER_AUDIT
  },
  XDOCK_VEHICLE_ATTENDANCE: {
    PATH: XDOCK_VEHICLE_ATTENDANCE
  },
  XDOCK_REGION_ALERTS: {
    PATH: XDOCK_REGION_ALERTS
  },
  VEHICLE_REGION_ASSIGNMENTS: {
    PATH: VEHICLE_REGION_ASSIGNMENTS
  },
  VEHICLE_REGION_AREAS: {
    PATH: VEHICLE_REGION_AREAS
  },
  XDOCK_DAILY_OPERATIONS_HISTORY: {
    PATH: XDOCK_DAILY_OPERATIONS_HISTORY
  },
  ROUTE_CACHE: {
    PATH: ROUTE_CACHE,
    EDIT: { PATH: EDIT }
  },
  COMPANY_UNLOADED_VOLUME: {
    PATH: COMPANY_UNLOADED_VOLUME
  },
  SUPPORT_REQUESTS: {
    PATH: SUPPORT_REQUESTS,
    DETAIL: { PATH: `${SUPPORT_REQUESTS}/${DETAIL}` }
  },
  CUSTOMER_FORM: {
    PATH: CUSTOMER_FORM,
    DETAIL: { PATH: `${CUSTOMER_FORM}/${DETAIL}` }
  },
  CUSTOMER_VISITS: {
    PATH: CUSTOMER_VISITS,
    DETAIL: { PATH: `${CUSTOMER_VISITS}/${DETAIL}` },
    EDIT: { PATH: `${CUSTOMER_VISITS}/${EDIT}` }
  },
  PANEL_NOTIFICATIONS: {
    PATH: PANEL_NOTIFICATIONS,
    EDIT: { PATH: EDIT }
  },
  CALL_FORWARDING: {
    PATH: CALL_FORWARDING,
    DETAIL: { PATH: DETAIL },
    EDIT: { PATH: EDIT }
  },
  ROUTE_SESSION: {
    PATH: ROUTE_SESSION
  },
  PACKAGE_TANZIM: {
    PATH: PACKAGE_TANZIM
  },
  DEALER_GROUPS: {
    PATH: DEALER_GROUPS,
    DETAIL: { PATH: `${DEALER_GROUPS}/${DETAIL}` },
    EDIT: { PATH: EDIT }
  },
  VEHICLE_TRACKING: {
    PATH: VEHICLE_TRACKING
  },
  COMPANY_MONITORING: {
    PATH: COMPANY_MONITORING,
    DETAIL: { PATH: `${COMPANY_MONITORING}/${DETAIL}` },
    EDIT: { PATH: `${COMPANY_MONITORING}/${EDIT}` }
  },
  MY_NOTIFICATIONS: {
    PATH: MY_NOTIFICATIONS
  },
  ORG_TITLES: {
    PATH: ORG_TITLES
  },
  ORG_STRUCTURE: {
    PATH: ORG_STRUCTURE
  },
  NOTIFICATION_TOPICS: {
    PATH: NOTIFICATION_TOPICS
  },
  NOTIFICATION_HISTORY: {
    PATH: NOTIFICATION_HISTORY
  },
  ORG_CHANGE_LOGS: {
    PATH: ORG_CHANGE_LOGS
  },
  TRANSFER_VEHICLE_ENTRANCE: {
    PATH: TRANSFER_VEHICLE_ENTRANCE,
    EDIT: { PATH: EDIT },
    DETAIL: { PATH: DETAIL },
    DELIVERY_NOTE: { PATH: 'delivery-note/:sessionIds' }
  },
  REGION_TRANSFER_TYPES: {
    PATH: REGION_TRANSFER_TYPES,
    EDIT: { PATH: EDIT }
  },
  ROUTE_SESSION_STATISTICS: {
    PATH: ROUTE_SESSION_STATISTICS,
    DETAIL: { PATH: `${ROUTE_SESSION_STATISTICS}/${DETAIL}` }
  },
  FULL_TRUCK_LOAD: {
    PATH: FULL_TRUCK_LOAD,
    EDIT: { PATH: EDIT }
  },
  DELIVERY_TIMES: {
    PATH: DELIVERY_TIMES,
    EDIT: { PATH: EDIT }
  },
  PUBLIC_HOLIDAYS: {
    PATH: PUBLIC_HOLIDAYS
  },
  TRANSFER_ROUTE_TIMES: {
    PATH: TRANSFER_ROUTE_TIMES
  },
  DELIVERY_CALCULATION: {
    PATH: DELIVERY_CALCULATION
  },
  DELIVERY_REPORT: {
    PATH: DELIVERY_REPORT
  },
  DELIVERY_CALCULATION_REGION: {
    PATH: DELIVERY_CALCULATION_REGION
  },
  SALES_CRM: {
    PATH: SALES_CRM,
    LEADS: {
      PATH: SALES_CRM_LEADS,
      DETAIL: { PATH: `${SALES_CRM_LEADS}/${DETAIL}` }
    },
    AGENDA: { PATH: SALES_CRM_AGENDA },
    QUOTES: { PATH: SALES_CRM_QUOTES },
    REPORTS: { PATH: SALES_CRM_REPORTS },
    SETTINGS: { PATH: SALES_CRM_SETTINGS }
  },
  CURRENT_ROUTE_PLAN: {
    PATH: CURRENT_ROUTE_PLAN
  },
  POINT_DISTRICTS: {
    PATH: POINT_DISTRICTS
  },
  CHAT_MESSAGES_LIST: {
    PATH: CHAT_MESSAGES_LIST,
    EDIT: { PATH: EDIT }
  },
  CONVERSATIONS: {
    PATH: CONVERSATIONS,
    DETAIL: { PATH: DETAIL }
  },
  CAREER_FORM: {
    PATH: CAREER_FORM,
    DETAIL: { PATH: `${CAREER_FORM}/${DETAIL}` }
  },
  OPEN_POSITIONS: {
    PATH: OPEN_POSITIONS,
    DETAIL: { PATH: `${OPEN_POSITIONS}/${DETAIL}` },
    EDIT: { PATH: `${OPEN_POSITIONS}/${EDIT}` }
  },
  DISTRIBUTION_EXPEDITIONS: {
    PATH: DISTRIBUTION_EXPEDITIONS,
    CREATE: { PATH: `${DISTRIBUTION_EXPEDITIONS}/create` },
    DETAIL: { PATH: `${DISTRIBUTION_EXPEDITIONS}/:id` },
    EDIT: { PATH: `${DISTRIBUTION_EXPEDITIONS}/edit/:id` },
    PRINT_A4: { PATH: `${DISTRIBUTION_EXPEDITIONS}/:id/print-a4` }
  },
  MOBILIZ_VEHICLE_DETAIL: {
    PATH: MOBILIZ_VEHICLE_DETAIL
  },
  MOBILIZ_FLEET: {
    PATH: MOBILIZ_FLEET
  },
  ETABLOLAR: {
    PATH: ETABLOLAR
  },
  DESKTOP_REPORT_USERS: {
    PATH: DESKTOP_REPORT_USERS
  },
  SAVED_REPORTS: {
    PATH: SAVED_REPORTS
  },
  NEIGHBOURHOODS: {
    PATH: NEIGHBOURHOODS,
    EDIT: { PATH: EDIT }
  },
  TICKETS: {
    PATH: TICKETS,
    DETAIL: { PATH: `${TICKETS}/${DETAIL}` },
    EDIT: { PATH: EDIT }
  },
  TICKET_TEAMS: {
    PATH: TICKET_TEAMS,
    DETAIL: { PATH: `${TICKET_TEAMS}/${DETAIL}` },
    EDIT: { PATH: EDIT }
  },
  TICKET_STATISTICS: {
    PATH: TICKET_STATISTICS
  },
  FEEDBACK: {
    PATH: FEEDBACK,
    NEW: { PATH: 'new' },
    DETAIL: { PATH: DETAIL }
  },
  FEEDBACK_ADMIN: {
    PATH: FEEDBACK_ADMIN
  },
  ACTIVITIES: {
    PATH: ACTIVITIES
  },
  BARCODE_ALERTS: {
    PATH: BARCODE_ALERTS,
    EDIT: { PATH: EDIT }
  },
  DEVICE_DIAGNOSTICS: {
    PATH: DEVICE_DIAGNOSTICS
  },
  REPLAY: {
    PATH: REPLAY,
    SETTINGS: { PATH: `${REPLAY}/settings` },
    DETAIL: { PATH: `${REPLAY}/:sessionId` }
  },
  AGREEMENT_LOGS: {
    PATH: AGREEMENT_LOGS
  },
  COMPANY_LOGS: {
    PATH: COMPANY_LOGS
  },
  VENDOR_LOGS: {
    PATH: VENDOR_LOGS
  },
  POINT_LOGS: {
    PATH: POINT_LOGS
  },
  POINT_MAP_LOGS: {
    PATH: POINT_MAP_LOGS
  },
  POINT_MAP_ADMIN: {
    PATH: POINT_MAP_ADMIN
  },
  FLEET_DASHBOARD: {
    PATH: FLEET_DASHBOARD
  },
  FLEET_VEHICLES: {
    PATH: FLEET_VEHICLES
  },
  FLEET_VEHICLE_DETAIL: {
    PATH: FLEET_VEHICLE_DETAIL
  },
  FLEET_VEHICLE_EDIT: {
    PATH: FLEET_VEHICLE_EDIT
  },
  FLEET_DRIVERS: {
    PATH: FLEET_DRIVERS
  },
  FLEET_DRIVER_DETAIL: {
    PATH: FLEET_DRIVER_DETAIL
  },
  FLEET_ASSIGNMENTS: {
    PATH: FLEET_ASSIGNMENTS
  },
  FLEET_DOCUMENTS: {
    PATH: FLEET_DOCUMENTS
  },
  FLEET_AGENDA: {
    PATH: FLEET_AGENDA
  },
  FLEET_NOTIFICATIONS: {
    PATH: FLEET_NOTIFICATIONS
  },
  FLEET_MAP: {
    PATH: FLEET_MAP
  },
  FLEET_WORK_ORDERS: {
    PATH: FLEET_WORK_ORDERS
  },
  FLEET_WORK_ORDER_DETAIL: {
    PATH: FLEET_WORK_ORDER_DETAIL
  },
  FLEET_PLANS: {
    PATH: FLEET_PLANS
  },
  FLEET_TIRES: {
    PATH: FLEET_TIRES
  },
  FLEET_INSPECTIONS: {
    PATH: FLEET_INSPECTIONS
  },
  FLEET_POLICIES: {
    PATH: FLEET_POLICIES
  },
  FLEET_OFFERS: {
    PATH: FLEET_OFFERS
  },
  FLEET_DAMAGES: {
    PATH: FLEET_DAMAGES
  },
  FLEET_DAMAGE_DETAIL: {
    PATH: FLEET_DAMAGE_DETAIL
  },
  FLEET_TOLLS: {
    PATH: FLEET_TOLLS
  },
  FLEET_FINES: {
    PATH: FLEET_FINES
  },
  FLEET_EXPENSES: {
    PATH: FLEET_EXPENSES
  },
  FLEET_BUDGETS: {
    PATH: FLEET_BUDGETS
  },
  FLEET_TCO: {
    PATH: FLEET_TCO
  },
  FLEET_REPORTS: {
    PATH: FLEET_REPORTS
  },
  FLEET_SUPPLIERS: {
    PATH: FLEET_SUPPLIERS
  },
  FLEET_CONTRACTS: {
    PATH: FLEET_CONTRACTS
  },
  FLEET_TIMESHEET: {
    PATH: FLEET_TIMESHEET
  },
  FLEET_SCORING: {
    PATH: FLEET_SCORING
  },
  FLEET_SCORING_DETAIL: {
    PATH: FLEET_SCORING_DETAIL
  },
  FLEET_INDICATORS: {
    PATH: FLEET_INDICATORS
  },
  FLEET_SCHEMES: {
    PATH: FLEET_SCHEMES
  },
  FLEET_OPTION_SETS: {
    PATH: FLEET_OPTION_SETS
  },
  FLEET_CUSTOM_FIELDS: {
    PATH: FLEET_CUSTOM_FIELDS
  },
  FLEET_AUTOMATIONS: {
    PATH: FLEET_AUTOMATIONS
  },
  FLEET_REMINDER_SETTINGS: {
    PATH: FLEET_REMINDER_SETTINGS
  },
  FLEET_AUDIT: {
    PATH: FLEET_AUDIT
  },
  FLEET_CARRIER_REQUESTS: {
    PATH: FLEET_CARRIER_REQUESTS
  },
  FLEET_CARRIER_REQUEST_DETAIL: {
    PATH: FLEET_CARRIER_REQUEST_DETAIL
  },
  VEHICLE_LOGS: {
    PATH: VEHICLE_LOGS
  },
  ROUTE_LOGS: {
    PATH: ROUTE_LOGS
  },
  ROUTE_SESSION_LOGS: {
    PATH: ROUTE_SESSION_LOGS
  },
  TRANSFER_VEHICLE_ENTRY_LOGS: {
    PATH: TRANSFER_VEHICLE_ENTRY_LOGS
  },
  VEHICLE_PLAN_LOGS: {
    PATH: VEHICLE_PLAN_LOGS
  },
  USER_LOGS: {
    PATH: USER_LOGS
  },
  ZERO_DESI_UPDATE: {
    PATH: ZERO_DESI_UPDATE
  },
  OLUSTURULDU_ISLEMLERI: {
    PATH: OLUSTURULDU_ISLEMLERI
  },
  ZERO_DESI_LOGS: {
    PATH: ZERO_DESI_LOGS
  },
  ONE_DESI_REPORT: {
    PATH: ONE_DESI_REPORT
  },
  SCAN_ZERO_DESI: {
    PATH: SCAN_ZERO_DESI
  },
  COMPANY_DESI_RANGES: {
    PATH: COMPANY_DESI_RANGES
  },
  DOCUMENT_LOGS: {
    PATH: DOCUMENT_LOGS
  },
  AUDIT_LOGS: {
    PATH: AUDIT_LOGS
  },
  MCP_AUDIT: {
    PATH: MCP_AUDIT
  },
  OKUTMA_TESHIS: {
    PATH: OKUTMA_TESHIS
  },
  SANTRAL_API: {
    PATH: SANTRAL_API
  },
  INSURER_ACCESS: {
    PATH: INSURER_ACCESS,
    GRANT: { PATH: INSURER_ACCESS_GRANT },
    GRANT_DETAIL: { PATH: INSURER_ACCESS_GRANT_DETAIL }
  },
  INSURERS: {
    PATH: INSURERS,
    INSURER: { PATH: INSURER_ACCESS_INSURER }
  },
  DELIVERY_TIME_LOGS: {
    PATH: DELIVERY_TIME_LOGS
  },
  PRICE_ESTIMATE_LOGS: {
    PATH: PRICE_ESTIMATE_LOGS
  },
  HARICI_KARGO: {
    PATH: HARICI_KARGO,
    CARRIERS: { PATH: 'firmalar' }
  },
  DEDIKE_NAKLIYE: {
    PATH: DEDIKE_NAKLIYE,
    EDIT: { PATH: 'edit/:id' },
    INVOICES: { PATH: 'faturalar' },
    INVOICE_DETAIL: { PATH: 'faturalar/:id' },
    RECONCILIATION: { PATH: 'mutabakat' },
    REPORTS: { PATH: 'raporlar' },
    PENDING: { PATH: 'eksikler' },
    COMPANY: { PATH: 'firma' },
    COMPANY_INVOICES: { PATH: 'firma/faturalar' },
    COMPANY_INVOICE_DETAIL: { PATH: 'firma/faturalar/:id' }
  },
  MULTI_SESSION_USERS: { PATH: MULTI_SESSION_USERS, EDIT: { PATH: EDIT } },
  SESSION_INVALIDATION_LOGS: {
    PATH: SESSION_INVALIDATION_LOGS
  },
  ZAIMBOT: {
    PATH: ZAIMBOT
  },
  AGENTZAIM: {
    PATH: AGENTZAIM
  },
  SPECIAL_VEHICLE_SUGGESTIONS: {
    PATH: SPECIAL_VEHICLE_SUGGESTIONS
  },
  CUSTOMER_TRACKING: {
    PATH: CUSTOMER_TRACKING,
    DETAIL: {
      PATH: `${CUSTOMER_TRACKING}/${DETAIL}`
    },
    ALERTS: {
      PATH: CUSTOMER_TRACKING_ALERTS
    }
  },
  UNDELIVERED_PACKAGES: {
    PATH: UNDELIVERED_PACKAGES
  },
  UNDELIVERED_PACKAGES_LOGS: {
    PATH: UNDELIVERED_PACKAGES_LOGS
  },
  BULK_RECALC_ROUTE: {
    PATH: BULK_RECALC_ROUTE
  },
  BULK_CALC_PRICE: {
    PATH: BULK_CALC_PRICE
  },
  CHECKLIST: {
    PATH: CHECKLIST,
    TASKS: { PATH: CHECKLIST_TASKS },
    TASKS_EDIT: { PATH: `${CHECKLIST_TASKS}/${EDIT}` },
    REPORT: { PATH: CHECKLIST_REPORT }
  },
  UNIT_DESI_AVERAGES: {
    PATH: UNIT_DESI_AVERAGES
  },
  COMPANY_VEHICLE_VISITS: {
    PATH: COMPANY_VEHICLE_VISITS
  },
  LOW_VOLUME_COMPANIES: {
    PATH: LOW_VOLUME_COMPANIES
  },
  EXTERNAL_CARGO_TRACKING: {
    PATH: EXTERNAL_CARGO_TRACKING
  },
  LIVE_MONITOR: {
    PATH: LIVE_MONITOR
  },
  REMOTE_ACCESS: {
    PATH: REMOTE_ACCESS
  },
  REMOTE_ACCESS_SESSION: {
    PATH: REMOTE_ACCESS_SESSION
  },
  CARGO_IN_WAREHOUSE: {
    PATH: CARGO_IN_WAREHOUSE
  },
  CARGO_IN_WAREHOUSE_LOGS: {
    PATH: CARGO_IN_WAREHOUSE_LOGS,
    DETAIL: { PATH: `${CARGO_IN_WAREHOUSE_LOGS}/${DETAIL}` }
  },
  DIA_CARI_SYNC: {
    PATH: DIA_CARI_SYNC
  },
  DIA_SYNC_HISTORY: {
    PATH: DIA_SYNC_HISTORY
  },
  DIA_UNMATCHED: {
    PATH: DIA_UNMATCHED
  },
  DIA_CARI_KARTLAR: {
    PATH: DIA_CARI_KARTLAR
  },
  DIA_IRSALIYE_AKTAR: {
    PATH: DIA_IRSALIYE_AKTAR
  },
  DIA_IRSALIYE_AYARLAR: {
    PATH: DIA_IRSALIYE_AYARLAR
  },
  DIA_IRSALIYE_OLUSTUR: {
    PATH: DIA_IRSALIYE_OLUSTUR
  },
  FUEL: {
    PATH: FUEL
  },
  FUEL_STATIONS: {
    PATH: FUEL_STATIONS
  }
};

export const URLS = {
  INDEX,
  LOGIN,
  PROFILE,
  FORGOT_PASSWORD,
  FORGOT,

  CSV_VENDOR_CREATE,
  CSV_INVENTORY_CREATE,

  DOCUMENT: `/${DOCUMENT}`,
  DOCUMENT_EDIT: (id: string) => `/${DOCUMENT}/${EDIT.replace(':id', String(id))}`,

  SHIPMENTS: `/${SHIPMENTS}`,
  SHIPMENTS_EDIT: (id: string | number) => `/${SHIPMENTS}/${EDIT.replace(':id', String(id))}`,
  SHIPMENTS_DETAIL: (id: string | number) => `/${SHIPMENTS}/${DETAIL.replace(':id', String(id))}`,

  RETURN_SHIPMENTS: `/${RETURN_SHIPMENTS}`,
  INTER_DEALER_SHIPMENT: `/${INTER_DEALER_SHIPMENT}`,
  DAMAGED_SHIPMENTS: `/${DAMAGED_SHIPMENTS}`,
  DESI_CHANGED_PACKAGES: `/${DESI_CHANGED_PACKAGES}`,

  SUPER_ADMIN_HISTORY: `/${SUPER_ADMIN_HISTORY}`,
  SUPER_ADMIN_HISTORY_DETAIL: (id: string) => `/${SUPER_ADMIN_HISTORY}/${DETAIL.replace(':id', id)}`,

  USER: `/${USER}`,
  USER_EDIT: (id: string | number) => `/${USER}/${EDIT.replace(':id', String(id))}`,
  USER_DETAIL: (id: string | number) => `/${USER}/${DETAIL.replace(':id', String(id))}`,
  USER_INVITE: `/${USER}/${USER_INVITE}`,
  USER_PERMISSIONS: (id: string | number) => `/${USER}/${USER_PERMISSIONS.replace(':id', String(id))}`,

  VENDORS: `/${VENDORS}`,
  VENDORS_EDIT: (id: string | number) => `/${VENDORS}/${EDIT.replace(':id', String(id))}`,
  VENDORS_DETAIL: (id: string | number) => `/${VENDORS}/${DETAIL.replace(':id', String(id))}`,
  VENDORS_ROUTE_CHANGE: (id: string | number) => `/${VENDORS}/${ROUTE_CHANGE.replace(':id', String(id))}`,
  VENDORS_DATE_CHANGE: (id: string | number) => `/${VENDORS}/${DATE_CHANGE.replace(':id', String(id))}`,

  COMPANIES: `/${COMPANIES}`,
  COMPANIES_EDIT: (id: string | number) => `/${COMPANIES}/${EDIT.replace(':id', String(id))}`,
  COMPANIES_ROUTE_CHANGE: (id: string | number) => `/${COMPANIES}/${ROUTE_CHANGE.replace(':id', String(id))}`,
  COMPANIES_DETAIL: (id: string | number) => `/${COMPANIES}/${DETAIL.replace(':id', String(id))}`,
  COMPANIES_RETURN_ROUTE_EDIT: (id: string | number) => `/${COMPANIES}/${RETURN_ROUTE_EDIT.replace(':id', String(id))}`,
  COMPANIES_COLLECTION_ROUTE_EDIT: (id: string | number) => `/${COMPANIES}/${COLLECTION_ROUTE_EDIT.replace(':id', String(id))}`,
  COMPANIES_USERS: (id: string | number) => `/${COMPANIES}/${USERS.replace(':id', String(id))}`,

  HARICI_KARGO: `/${HARICI_KARGO}`,
  HARICI_KARGO_FIRMALAR: `/${HARICI_KARGO}/firmalar`,
  DEDIKE_NAKLIYE: `/${DEDIKE_NAKLIYE}`,
  DEDIKE_NAKLIYE_NEW: `/${DEDIKE_NAKLIYE}/edit/new`,
  DEDIKE_NAKLIYE_EDIT: (id: string) => `/${DEDIKE_NAKLIYE}/edit/${id}`,
  DEDIKE_NAKLIYE_INVOICES: `/${DEDIKE_NAKLIYE}/faturalar`,
  DEDIKE_NAKLIYE_INVOICE: (id: string) => `/${DEDIKE_NAKLIYE}/faturalar/${id}`,
  DEDIKE_NAKLIYE_RECONCILIATION: `/${DEDIKE_NAKLIYE}/mutabakat`,
  DEDIKE_NAKLIYE_REPORTS: `/${DEDIKE_NAKLIYE}/raporlar`,
  DEDIKE_NAKLIYE_PENDING: `/${DEDIKE_NAKLIYE}/eksikler`,
  DEDIKE_NAKLIYE_COMPANY: `/${DEDIKE_NAKLIYE}/firma`,
  DEDIKE_NAKLIYE_COMPANY_INVOICES: `/${DEDIKE_NAKLIYE}/firma/faturalar`,
  DEDIKE_NAKLIYE_COMPANY_INVOICE: (id: string) => `/${DEDIKE_NAKLIYE}/firma/faturalar/${id}`,
  COMPANY_CATEGORIES: `/${COMPANY_CATEGORIES}`,
  COMPANY_CATEGORIES_NEW: `/${COMPANY_CATEGORIES}/edit/new`,
  COMPANY_CATEGORIES_EDIT: (id: string | number) => `/${COMPANY_CATEGORIES}/edit/${String(id)}`,
  COMPANY_CATEGORIES_DETAIL: (id: string | number) => `/${COMPANY_CATEGORIES}/${String(id)}`,
  COMPANY_CATEGORIES_UNCATEGORIZED: `/${COMPANY_CATEGORIES}/kategorisiz`,

  INVITED_USERS: `/${INVITED_USERS}`,

  DAILY_ROUTE: `/${DAILY_ROUTE}`,
  DAILY_ROUTE_EDIT: (id: string | number) => `/${DAILY_ROUTE}/${EDIT.replace(':id', String(id))}`,
  DAILY_ROUTE_DETAIL: (id: string | number) => `/${DAILY_ROUTE}/${DETAIL.replace(':id', String(id))}`,
  DAILY_ROUTE_FILE_UPLOAD: (id: string | number) => `/${DAILY_ROUTE}/${FILE_UPLOAD.replace(':id', String(id))}`,
  DAILY_ROUTE_INVOICE_UPLOAD: (id: string | number) => `/${DAILY_ROUTE}/${INVOICE_UPLOAD.replace(':id', String(id))}`,
  DAILY_ROUTE_REPORT_DOWNLOAD: (id: string | number) => `/${DAILY_ROUTE}/${REPORT_DOWNLOAD.replace(':id', String(id))}`,
  DAILY_ROUTE_VEHICLE_CHANGE: (id: string | number) => `/${DAILY_ROUTE}/${VEHICLE_CHANGE.replace(':id', String(id))}`,
  DAILY_ROUTE_FILES: (id: string | number) => `/${DAILY_ROUTE}/${FILES.replace(':id', String(id))}`,
  DAILY_ROUTE_INTERMEDIATE_TRANSFER_DELIVERY_NOTE: (id: string | number) =>
    `/${DAILY_ROUTE}/${INTERMEDIATE_TRANSFER_DELIVERY_NOTE.replace(':id', String(id))}`,
  DAILY_ROUTE_DELIVERY_NOTE: (id: string | number, type: string) =>
    `/${DAILY_ROUTE}/${DELIVERY_NOTE.replace(':id', String(id)).replace(':type', type)}`,
  DAILY_ROUTE_PRINT_A4: (id: string | number) => `/${DAILY_ROUTE}/${PRINT_A4.replace(':id', String(id))}`,
  DAILY_ROUTE_DAILY_ROUTE_DRIVER_EDIT: (id: string | number) => `/${DAILY_ROUTE}/${DAILY_ROUTE_DRIVER_EDIT.replace(':id', String(id))}`,

  INVOICES: `/${INVOICES}`,

  INFO: `/${INFO}`,

  INVENTORY: `/${INVENTORY}`,
  INVENTORY_EDIT: (id: string | number) => `/${INVENTORY}/${EDIT.replace(':id', String(id))}`,
  INVENTORY_DETAIL: (id: string | number) => `/${INVENTORY}/${DETAIL.replace(':id', String(id))}`,

  DEVICEREQUEST: `/${DEVICEREQUEST}`,
  DEVICEREQUEST_EDIT: (id: string | number) => `/${DEVICEREQUEST}/${EDIT.replace(':id', String(id))}`,

  DEVICE_STATUS: `/${DEVICE_STATUS}`,
  DEVICE_STATUS_EDIT: (id: string | number) => `/${DEVICE_STATUS}/${EDIT.replace(':id', String(id))}`,

  DEVICE_TYPE: `/${DEVICE_TYPE}`,
  DEVICE_TYPE_EDIT: (id: string | number) => `/${DEVICE_TYPE}/${EDIT.replace(':id', String(id))}`,

  BRANDS: `/${BRANDS}`,
  BRANDS_EDIT: (id: string | number) => `/${BRANDS}/${EDIT.replace(':id', String(id))}`,

  MODELS: `/${MODELS}`,
  MODELS_EDIT: (id: string | number) => `/${MODELS}/${EDIT.replace(':id', String(id))}`,

  INVENTORY_LOGS: `/${INVENTORY_LOGS}`,
  INVENTORY_LOGS_DETAIL: (id: string | number) => `/${INVENTORY_LOGS}/${DETAIL.replace(':id', String(id))}`,

  WEIGHBRIDGE: `/${WEIGHBRIDGE}`,

  BARCODE: `/${BARCODE}`,
  BARCODE_EDIT: (id: string | number) => `/${BARCODE}/${EDIT.replace(':id', String(id))}`,
  BARCODE_RETURN_BARCODE_CREATE: `/${BARCODE}/${RETURN_BARCODE_CREATE}`,
  BARCODE_V2V_BARCODE_CREATE: `/${BARCODE}/${V2V_BARCODE_CREATE}`,
  BARCODE_LOST_BARCODE_CREATE: `/${BARCODE}/${LOST_BARCODE_CREATE}`,

  TRANSFER_AREA: `/${TRANSFER_AREA}`,

  SEND_EMAIL: `/${SEND_EMAIL}`,
  SEND_EMAIL_EDIT: (id: string | number) => `/${SEND_EMAIL}/${EDIT.replace(':id', String(id))}`,

  BULK_EMAIL: `/${BULK_EMAIL}`,
  BULK_EMAIL_NEW: `/${BULK_EMAIL}/new`,
  BULK_EMAIL_DETAIL: (id: string | number) => `/${BULK_EMAIL}/${DETAIL.replace(':id', String(id))}`,

  COUNTRIES: `/${COUNTRIES}`,
  COUNTRIES_EDIT: (id: string | number) => `/${COUNTRIES}/${EDIT.replace(':id', String(id))}`,
  COUNTRIES_DETAIL: (id: string | number) => `/${COUNTRIES}/${DETAIL.replace(':id', String(id))}`,

  CITIES: `/${CITIES}`,
  CITIES_EDIT: (id: string | number) => `/${CITIES}/${EDIT.replace(':id', String(id))}`,
  CITIES_DETAIL: (id: string | number) => `/${CITIES}/${DETAIL.replace(':id', String(id))}`,

  DISTRICTS: `/${DISTRICTS}`,
  DISTRICTS_EDIT: (id: string | number) => `/${DISTRICTS}/${EDIT.replace(':id', String(id))}`,
  DISTRICTS_DETAIL: (id: string | number) => `/${DISTRICTS}/${DETAIL.replace(':id', String(id))}`,

  REPORTS_SHIPMENTS: `/${REPORTS}/${SHIPMENTS}`,
  REPORTS_ALL_SHIPMENTS: `/${REPORTS}/${ALL_SHIPMENTS}`,
  REPORTS_PERSONEL_LOG: `/${REPORTS}/${PERSONEL_LOG}`,
  REPORTS_VEHICLE_PLANING: `/${REPORTS}/${VEHICLE_PLANING}`,
  REPORTS_RETURN_SHIPMENTS: `/${REPORTS}/${RETURN_SHIPMENTS}`,
  REPORTS_DAMAGE_SHIPMENTS: `/${REPORTS}/${DAMAGED_SHIPMENTS}`,
  REPORTS_INTER_DEALER_SHIPMENT: `/${REPORTS}/${INTER_DEALER_SHIPMENT}`,
  REPORTS_LOST_PACKAGES: `/${REPORTS}/${LOST_PACKAGES}`,
  REPORTS_CALL_FORWARDING: `/${REPORTS}/${CALL_FORWARDING}`,
  REPORTS_ROUTE_SESSION: `/${REPORTS}/${ROUTE_SESSION}`,
  REPORTS_ROUTE_SESSION_SPECIAL: `/${REPORTS}/${ROUTE_SESSION_SPECIAL}`,
  REPORTS_ROUTE_SESSION_FILE_CHECK: `/${REPORTS}/${ROUTE_SESSION_FILE_CHECK}`,
  REPORTS_PLATE_EVENTS: `/${REPORTS}/${PLATE_EVENTS_REPORT}`,
  REPORTS_INDEX_ROUTE_SESSIONS_OLUSTURULDU: `/${REPORTS}/${INDEX_ROUTE_SESSIONS_OLUSTURULDU}`,
  REPORTS_MONTHLY_COMPANY_REPORT: `/${REPORTS}/${MONTHLY_COMPANY_REPORT}`,
  REPORTS_WEEKLY_COMPANY_REPORT: `/${REPORTS}/${WEEKLY_COMPANY_REPORT}`,
  REPORTS_DAILY_COMPANY_REPORT: `/${REPORTS}/${DAILY_COMPANY_REPORT}`,
  REPORTS_PACKAGE_DESI_CHANGE_REPORT: `/${REPORTS}/${PACKAGE_DESI_CHANGE_REPORT}`,
  REPORTS_PACKAGE_CONTROL_REPORT: `/${REPORTS}/${PACKAGE_CONTROL_REPORT}`,
  REPORTS_SUPER_ADMIN_HISTORY_REPORT: `/${REPORTS}/${SUPER_ADMIN_HISTORY_REPORT}`,
  REPORTS_VEHICLES: `/${REPORTS}/${VEHICLES_REPORT}`,
  REPORTS_TRANSFER_VEHICLE_ENTRY: `/${REPORTS}/${TRANSFER_VEHICLE_ENTRY_REPORT}`,
  REPORTS_TRANSFER_ROUTE_REPORT: `/${REPORTS}/${TRANSFER_ROUTE_REPORT}`,
  REPORTS_COMPANIES_DETAIL_REPORT: `/${REPORTS}/${COMPANIES_DETAIL_REPORT}`,
  REPORTS_VENDORS_DETAIL_REPORT: `/${REPORTS}/${VENDORS_DETAIL_REPORT}`,
  REPORTS_VEHICLE_REQUEST_REPORT: `/${REPORTS}/${VEHICLE_REQUEST_REPORT}`,
  REPORTS_CARGO_IN_WAREHOUSE: `/${REPORTS}/cargo-in-warehouse-report`,
  REPORTS_DISTRIBUTION_EXPEDITIONS: `/${REPORTS}/${DISTRIBUTION_EXPEDITIONS_REPORT}`,

  SHIPMENT_DELIVERY: `/${SHIPMENT_DELIVERY}`,

  PACK_TYPES: `/${PACK_TYPES}`,
  PACK_TYPES_EDIT: (id: string | number) => `/${PACK_TYPES}/${EDIT.replace(':id', String(id))}`,

  PACKAGE_CONTROL: `/${PACKAGE_CONTROL}`,
  PACKAGE_CONTROL_CREATE: `/${PACKAGE_CONTROL}/edit/create`,
  PACKAGE_CONTROL_EDIT: `/${PACKAGE_CONTROL}/edit/:id`,
  PACKAGE_CONTROL_DETAIL: `/${PACKAGE_CONTROL}/detail/:id`,

  VEHICLES: `/${VEHICLES}`,
  VEHICLES_EDIT: (id: string | number) => `/${VEHICLES}/${EDIT.replace(':id', String(id))}`,

  VEHICLE_CATEGORY: `/${VEHICLE_CATEGORY}`,
  VEHICLE_CATEGORY_EDIT: (id: string | number) => `/${VEHICLE_CATEGORY}/${EDIT.replace(':id', String(id))}`,

  FORD_INTEGRATION_TRIGGER: `/${FORD_INTEGRATION_TRIGGER}`,

  VEHICLE_PLANING: `/${VEHICLE_PLANING}`,
  VEHICLE_PLANING_EDIT: (id: string | number) => `/${VEHICLE_PLANING}/${EDIT.replace(':id', String(id))}`,

  VEHICLE_REQUEST: `/${VEHICLE_REQUEST}`,
  VEHICLE_REQUEST_EDIT: (id: string | number) => `/${VEHICLE_REQUEST}/${EDIT.replace(':id', String(id))}`,
  VEHICLE_REQUEST_DETAIL: (id: string | number) => `/${VEHICLE_REQUEST}/${DETAIL.replace(':id', String(id))}`,
  PACKAGE_REQUEST: `/${PACKAGE_REQUEST}`,
  PACKAGE_REQUEST_EDIT: (id: string | number) => `/${PACKAGE_REQUEST}/${EDIT.replace(':id', String(id))}`,
  PACKAGE_REQUEST_DETAIL: (id: string | number) => `/${PACKAGE_REQUEST}/${DETAIL.replace(':id', String(id))}`,
  DESI_ADET_KONTROL: `/${DESI_ADET_KONTROL}`,
  DESI_ADET_KONTROL_CREATE: `/${DESI_ADET_KONTROL}/new`,
  DESI_ADET_KONTROL_DETAIL: (id: string | number) => `/${DESI_ADET_KONTROL}/${DETAIL.replace(':id', String(id))}`,
  DESI_ADET_KONTROL_LOGS: `/${DESI_ADET_KONTROL_LOGS}`,
  EXCEL_PACKAGE_PRICE_UPDATE: `/${EXCEL_PACKAGE_PRICE_UPDATE}`,

  SUPPLIERS: `/${SUPPLIERS}`,
  SUPPLIERS_EDIT: (id: string | number) => `/${SUPPLIERS}/${EDIT.replace(':id', String(id))}`,

  WAREHOUSE_VEHICLE_ENTRANCE: `/${WAREHOUSE_VEHICLE_ENTRANCE}`,

  DEPOT_LAYOUT: `/${DEPOT_LAYOUT}`,

  RAMP_ASSIGNMENT: `/${RAMP_ASSIGNMENT}`,

  RAMP_OCCUPANCY: `/${RAMP_OCCUPANCY}`,

  RAMP_ANALYTICS: `/${RAMP_ANALYTICS}`,

  DEMAND_FORECAST: `/${DEMAND_FORECAST}`,

  DEMAND_FORECAST_ACCURACY: `/${DEMAND_FORECAST_ACCURACY}`,

  DEMAND_FORECAST_METHODOLOGY: `/${DEMAND_FORECAST_METHODOLOGY}`,

  RAMP_BOARD: `/${RAMP_BOARD}`,

  PLAKA_OKUMA: `/${PLAKA_OKUMA}`,

  PURCHASE_ORDERS: `/${PURCHASE_ORDERS}`,
  PURCHASE_ORDERS_EDIT: (id: string | number) => `/${PURCHASE_ORDERS}/${EDIT.replace(':id', String(id))}`,
  PURCHASE_REQUESTS: `/${PURCHASE_REQUESTS}`,
  PURCHASE_REQUESTS_EDIT: (id: string | number) => `/${PURCHASE_REQUESTS}/${EDIT.replace(':id', String(id))}`,
  PURCHASING_APPROVALS: `/${PURCHASING_APPROVALS}`,
  PURCHASING_RFQS: `/${PURCHASING_RFQS}`,
  PURCHASING_RFQS_EDIT: (id: string | number) => `/${PURCHASING_RFQS}/${EDIT.replace(':id', String(id))}`,
  PURCHASING_WORKFLOWS: `/${PURCHASING_WORKFLOWS}`,
  DIA_SUPPLIERS: `/${DIA_SUPPLIERS}`,
  DIA_API_LOGS: `/${DIA_API_LOGS}`,
  DIA_DURUM: `/${DIA_DURUM}`,
  GOODS_RECEIPTS: `/${GOODS_RECEIPTS}`,
  PURCHASING_ANALYTICS: `/${PURCHASING_ANALYTICS}`,
  PURCHASING_REPORTS: `/${PURCHASING_REPORTS}`,
  INVOICE_MATCHING: `/${INVOICE_MATCHING}`,
  EFATURA_ARCHIVE: `/${EFATURA_ARCHIVE}`,
  EFATURA_ARCHIVE_DETAIL: (id: string | number) => `/${EFATURA_ARCHIVE}/${DETAIL.replace(':id', String(id))}`,
  PURCHASING_DEFINITIONS: `/${PURCHASING_DEFINITIONS}`,
  PURCHASING_ROLES: `/${PURCHASING_ROLES}`,
  PURCHASING_ORG: `/${PURCHASING_ORG}`,
  PURCHASING_CUSTOM_FIELDS: `/${PURCHASING_CUSTOM_FIELDS}`,
  PURCHASING_GUIDE: `/${PURCHASING_GUIDE}`,

  CREATE_MICRO_ROUTE: `/${CREATE_MICRO_ROUTE}`,
  CREATE_MICRO_ROUTE_EDIT: (id: string | number) => `/${CREATE_MICRO_ROUTE}/${EDIT.replace(':id', String(id))}`,

  ROUTE: `/${ROUTE}`,
  ROUTE_EDIT: (id: string | number) => `/${ROUTE}/${EDIT.replace(':id', String(id))}`,

  CREATE_COMPANY_ROUTE: `/${CREATE_COMPANY_ROUTE}`,
  CREATE_COMPANY_ROUTE_EDIT: (id: string | number) => `/${CREATE_COMPANY_ROUTE}/${EDIT.replace(':id', String(id))}`,

  MICRO_ROUTE_TRANSPORTATION: `/${MICRO_ROUTE_TRANSPORTATION}`,
  MICRO_ROUTE_TRANSPORTATION_EDIT: (id: string | number) => `/${MICRO_ROUTE_TRANSPORTATION}/${EDIT.replace(':id', String(id))}`,

  REGION_MICRO_TRANSPORTATION: `/${REGION_MICRO_TRANSPORTATION}`,
  REGION_MICRO_TRANSPORTATION_EDIT: (id: string | number) => `/${REGION_MICRO_TRANSPORTATION}/${EDIT.replace(':id', String(id))}`,

  PROVINCE_ROUTE_TRANSPORTATION: `/${PROVINCE_ROUTE_TRANSPORTATION}`,
  PROVINCE_ROUTE_TRANSPORTATION_EDIT: (id: string | number) => `/${PROVINCE_ROUTE_TRANSPORTATION}/${EDIT.replace(':id', String(id))}`,

  DISTRICT_ROUTE_TRANSPORTATION: `/${DISTRICT_ROUTE_TRANSPORTATION}`,
  DISTRICT_ROUTE_TRANSPORTATION_EDIT: (id: string | number) => `/${DISTRICT_ROUTE_TRANSPORTATION}/${EDIT.replace(':id', String(id))}`,

  CONTAINERS: `/${CONTAINERS}`,
  CONTAINERS_EDIT: (id: string | number) => `/${CONTAINERS}/${EDIT.replace(':id', String(id))}`,
  CONTAINERS_DETAIL: (id: string | number) => `/${CONTAINERS}/${DETAIL.replace(':id', String(id))}`,

  PERSONEL: `/${PERSONEL}`,
  PERSONEL_EDIT: (id: string | number) => `/${PERSONEL}/${EDIT.replace(':id', String(id))}`,
  PERSONEL_DETAIL: (id: string | number) => `/${PERSONEL}/${DETAIL.replace(':id', String(id))}`,

  PERSONEL_SUPPLIER: `/${PERSONEL_SUPPLIER}`,
  PERSONEL_SUPPLIERS_EDIT: (id: string | number) => `/${PERSONEL_SUPPLIER}/${EDIT.replace(':id', String(id))}`,

  PERSONEL_ENTRANCE_EXIT: `/${PERSONEL_ENTRANCE_EXIT}`,
  PERSONEL_ENTRANCE_EXIT_EDIT: (id: string | number) => `/${PERSONEL_ENTRANCE_EXIT}/${EDIT.replace(':id', String(id))}`,
  PERSONEL_ENTRANCE_EXIT_DETAIL: (id: string | number) => `/${PERSONEL_ENTRANCE_EXIT}/${DETAIL.replace(':id', String(id))}`,

  SHIFTS: `/${SHIFTS}`,
  SHIFTS_EDIT: (id: string) => `/${SHIFTS}/${EDIT.replace(':id', id)}`,

  MISSION: `/${MISSION}`,
  MISSION_EDIT: (id: string) => `/${MISSION}/${EDIT.replace(':id', id)}`,

  DOOR: `/${DOOR}`,
  DOOR_EDIT: (id: string) => `/${DOOR}/${EDIT.replace(':id', id)}`,

  LOST_PACKAGES: `/${LOST_PACKAGES}`,
  LOST_PACKAGES_LOSS_BARCODE_CREATE: `/${LOST_PACKAGES}/loss-barcode-create`,
  LOST_PACKAGES_HELP: `/${LOST_PACKAGES}/help`,
  LOST_PACKAGES_EDIT: (id: string | number) => `/${LOST_PACKAGES}/${EDIT.replace(':id', String(id))}`,
  LOST_PACKAGES_DETAIL: (id: string | number) => `/${LOST_PACKAGES}/${DETAIL.replace(':id', String(id))}`,

  CITY_DISTRICT_ROUTE_EDIT: `/${CITY_DISTRICT_ROUTE_EDIT}`,
  CITY_DISTRICT_ROUTE_EDIT_EDIT: (id: string | number) => `/${CITY_DISTRICT_ROUTE_EDIT}/${EDIT.replace(':id', String(id))}`,

  MANUEL_BARCODE_PRINT: `/${MANUEL_BARCODE_PRINT}`,

  APPS: `/${APPS}`,
  APPS_EDIT: (id: string | number) => `/${APPS}/${EDIT.replace(':id', String(id))}`,
  APPS_DETAIL: (id: string | number) => `/${APPS}/${DETAIL.replace(':id', String(id))}`,

  AGREEMENTS: `/${AGREEMENTS}`,
  AGREEMENTS_EDIT: (id: string) => `/${AGREEMENTS}/${EDIT.replace(':id', String(id))}`,

  WEBHOOKS: `/${WEBHOOKS}`,
  WEBHOOKS_EDIT: (id: string) => `/${WEBHOOKS}/${EDIT.replace(':id', String(id))}`,

  BULK_PRINTING_RETURN_SHIPMENTS: `/${BULK_PRINTING}/${RETURN_SHIPMENTS}`,
  BULK_PRINTING_SHIPMENTS: `/${BULK_PRINTING}/${SHIPMENTS}`,
  BULK_PRINTING_INTER_DEALER_SHIPMENT: `/${BULK_PRINTING}/${INTER_DEALER_SHIPMENT}`,

  REGION: `/${REGION}`,
  REGION_EDIT: (id: string | number) => `/${REGION}/${EDIT.replace(':id', String(id))}`,
  REGION_DETAIL: (id: string | number) => `/${REGION}/${DETAIL.replace(':id', String(id))}`,
  REGION_CONTACT_EDIT: (id: string | number, regionId: string | number) =>
    `/${REGION}/${CONTACT_EDIT.replace(':id', String(id)).replace(':regionId', String(regionId))}`,

  OLD_RETURN_PACKAGE: `/${OLD_RETURN_PACKAGE}`,

  COMPANY_DAILY_VOLUME: `/${COMPANY_DAILY_VOLUME}`,
  COMPANY_UNLOADED_VOLUME: `/${COMPANY_UNLOADED_VOLUME}`,
  ROUTE_DAILY_VOLUME: `/${ROUTE_DAILY_VOLUME}`,

  BULKCHANGE_USERS: `/${BULKCHANGE_USERS}`,

  XDOCKS_DAILY_VOLUME: `/${XDOCKS_DAILY_VOLUME}`,
  XDOCKS_DAILY_VOLUME_DETAIL: (id: string | number) => `/${XDOCKS_DAILY_VOLUME}/${DETAIL.replace(':id', String(id))}`,
  XDOCK_DAILY_OPERATIONS: `/${XDOCK_DAILY_OPERATIONS}`,
  TRANSFER_AUDIT: `/${TRANSFER_AUDIT}`,
  XDOCK_VEHICLE_ATTENDANCE: `/${XDOCK_VEHICLE_ATTENDANCE}`,
  XDOCK_REGION_ALERTS: `/${XDOCK_REGION_ALERTS}`,
  VEHICLE_REGION_ASSIGNMENTS: `/${VEHICLE_REGION_ASSIGNMENTS}`,
  VEHICLE_REGION_AREAS: `/${VEHICLE_REGION_AREAS}`,
  XDOCK_DAILY_OPERATIONS_HISTORY: `/${XDOCK_DAILY_OPERATIONS_HISTORY}`,

  ROUTE_CACHE: `/${ROUTE_CACHE}`,
  ROUTE_CACHE_EDIT: (id: string | number) => `/${ROUTE_CACHE}/${EDIT.replace(':id', String(id))}`,

  SUPPORT_REQUESTS: `/${SUPPORT_REQUESTS}`,
  SUPPORT_REQUESTS_DETAIL: (id: string | number) => `/${SUPPORT_REQUESTS}/${DETAIL.replace(':id', encodeURIComponent(String(id)))}`,
  CUSTOMER_FORM: `/${CUSTOMER_FORM}`,
  CUSTOMER_FORM_DETAIL: (id: string | number) => `/${CUSTOMER_FORM}/${DETAIL.replace(':id', String(id))}`,

  CUSTOMER_VISITS: `/${CUSTOMER_VISITS}`,
  CUSTOMER_VISITS_DETAIL: (id: string | number) => `/${CUSTOMER_VISITS}/${DETAIL.replace(':id', String(id))}`,
  CUSTOMER_VISITS_EDIT: (id: string | number) => `/${CUSTOMER_VISITS}/${EDIT.replace(':id', String(id))}`,

  PANEL_NOTIFICATIONS: `/${PANEL_NOTIFICATIONS}`,
  PANEL_NOTIFICATIONS_EDIT: (id: string | number) => `/${PANEL_NOTIFICATIONS}/${EDIT.replace(':id', String(id))}`,

  CALL_FORWARDING: `/${CALL_FORWARDING}`,
  CALL_FORWARDING_EDIT: (id: string | number) => `/${CALL_FORWARDING}/${EDIT.replace(':id', String(id))}`,
  CALL_FORWARDING_DETAIL: (id: string | number) => `/${CALL_FORWARDING}/${DETAIL.replace(':id', String(id))}`,

  PACKAGE_TANZIM: `/${PACKAGE_TANZIM}`,

  DEALER_GROUPS: `/${DEALER_GROUPS}`,
  DEALER_GROUPS_DETAIL: (id: string | number) => `/${DEALER_GROUPS}/${DETAIL.replace(':id', String(id))}`,
  DEALER_GROUPS_EDIT: (id: string | number) => `/${DEALER_GROUPS}/${EDIT.replace(':id', String(id))}`,
  DEALER_GROUPS_ANALYZE: `/${DEALER_GROUPS}/analyze`,

  VEHICLE_TRACKING: `/${VEHICLE_TRACKING}`,

  COMPANY_MONITORING: `/${COMPANY_MONITORING}`,
  COMPANY_MONITORING_DETAIL: (id: string | number) => `/${COMPANY_MONITORING}/${DETAIL.replace(':id', String(id))}`,
  COMPANY_MONITORING_EDIT: (id: string | number) => `/${COMPANY_MONITORING}/${EDIT.replace(':id', String(id))}`,

  MY_NOTIFICATIONS: `/${MY_NOTIFICATIONS}`,
  /** Bildirimlerim sekmesi (sözleşme §5: ?tab=announcements|system|fleet|region) */
  MY_NOTIFICATIONS_TAB: (tab: 'announcements' | 'system' | 'fleet' | 'region') => `/${MY_NOTIFICATIONS}?tab=${tab}`,
  ORG_TITLES: `/${ORG_TITLES}`,
  ORG_STRUCTURE: `/${ORG_STRUCTURE}`,
  NOTIFICATION_TOPICS: `/${NOTIFICATION_TOPICS}`,
  NOTIFICATION_HISTORY: `/${NOTIFICATION_HISTORY}`,
  ORG_CHANGE_LOGS: `/${ORG_CHANGE_LOGS}`,

  COMPANY_EXIT: `/${COMPANY_EXIT}`,

  TRANSFER_VEHICLE_ENTRANCE: `/${TRANSFER_VEHICLE_ENTRANCE}`,
  TRANSFER_VEHICLE_ENTRANCE_EDIT: (id: string | number) => `/${TRANSFER_VEHICLE_ENTRANCE}/${EDIT.replace(':id', String(id))}`,
  TRANSFER_VEHICLE_ENTRANCE_DETAIL: (id: string | number) => `/${TRANSFER_VEHICLE_ENTRANCE}/${DETAIL.replace(':id', String(id))}`,
  TRANSFER_VEHICLE_ENTRANCE_LOGS: (id: string | number) => `/${TRANSFER_VEHICLE_ENTRANCE}/logs/${id}`,
  TRANSFER_VEHICLE_ENTRANCE_DELIVERY_NOTE: (sessionIds: string | number | number[]) => {
    const ids = Array.isArray(sessionIds) ? sessionIds.join(',') : String(sessionIds);
    return `/${TRANSFER_VEHICLE_ENTRANCE}/delivery-note/${ids}`;
  },

  REGION_TRANSFER_TYPES: `/${REGION_TRANSFER_TYPES}`,
  REGION_TRANSFER_TYPES_EDIT: (id: string | number) => `/${REGION_TRANSFER_TYPES}/${EDIT.replace(':id', String(id))}`,

  ROUTE_SESSION_STATISTICS: `/${ROUTE_SESSION_STATISTICS}`,
  ROUTE_SESSION_STATISTICS_DETAIL: (id: string | number) => `/${ROUTE_SESSION_STATISTICS}/${DETAIL.replace(':id', String(id))}`,

  FULL_TRUCK_LOAD: `/${FULL_TRUCK_LOAD}`,
  FULL_TRUCK_LOAD_EDIT: (id: string | number) => `/${FULL_TRUCK_LOAD}/${EDIT.replace(':id', String(id))}`,

  DELIVERY_TIMES: `/${DELIVERY_TIMES}`,
  DELIVERY_TIMES_EDIT: (id: string | number) => `/${DELIVERY_TIMES}/${EDIT.replace(':id', String(id))}`,
  PUBLIC_HOLIDAYS: `/${PUBLIC_HOLIDAYS}`,

  TRANSFER_ROUTE_TIMES: `/${TRANSFER_ROUTE_TIMES}`,

  DELIVERY_CALCULATION: `/${DELIVERY_CALCULATION}`,
  DELIVERY_REPORT: `/${DELIVERY_REPORT}`,
  DELIVERY_CALCULATION_REGION: `/${DELIVERY_CALCULATION_REGION}`,

  SALES_CRM: `/${SALES_CRM}`,
  SALES_CRM_LEADS: `/${SALES_CRM_LEADS}`,
  SALES_CRM_LEAD_DETAIL: (id: string | number) => `/${SALES_CRM_LEADS}/${DETAIL.replace(':id', String(id))}`,
  SALES_CRM_AGENDA: `/${SALES_CRM_AGENDA}`,
  SALES_CRM_QUOTES: `/${SALES_CRM_QUOTES}`,
  SALES_CRM_REPORTS: `/${SALES_CRM_REPORTS}`,
  SALES_CRM_SETTINGS: `/${SALES_CRM_SETTINGS}`,

  CURRENT_ROUTE_PLAN: `/${CURRENT_ROUTE_PLAN}`,
  CURRENT_ROUTE_PLAN_ISTANBUL: `/${CURRENT_ROUTE_PLAN}?from_city_code=34`,
  CURRENT_ROUTE_PLAN_ANKARA: `/${CURRENT_ROUTE_PLAN}?from_city_code=6`,
  CURRENT_ROUTE_PLAN_ADANA: `/${CURRENT_ROUTE_PLAN}?from_city_code=1`,
  CURRENT_ROUTE_PLAN_GAZIANTEP: `/${CURRENT_ROUTE_PLAN}?from_city_code=27`,
  CURRENT_ROUTE_PLAN_DIYARBAKIR: `/${CURRENT_ROUTE_PLAN}?from_city_code=21`,
  CURRENT_ROUTE_PLAN_IZMIR: `/${CURRENT_ROUTE_PLAN}?from_city_code=35`,
  CURRENT_ROUTE_PLAN_AFYON: `/${CURRENT_ROUTE_PLAN}?from_city_code=3`,
  CURRENT_ROUTE_PLAN_ANTALYA: `/${CURRENT_ROUTE_PLAN}?from_city_code=7`,
  CURRENT_ROUTE_PLAN_BALIKESIR: `/${CURRENT_ROUTE_PLAN}?from_city_code=10`,
  CURRENT_ROUTE_PLAN_BURSA: `/${CURRENT_ROUTE_PLAN}?from_city_code=16`,
  CURRENT_ROUTE_PLAN_DENIZLI: `/${CURRENT_ROUTE_PLAN}?from_city_code=20`,
  CURRENT_ROUTE_PLAN_ESKISEHIR: `/${CURRENT_ROUTE_PLAN}?from_city_code=26`,
  CURRENT_ROUTE_PLAN_KONYA: `/${CURRENT_ROUTE_PLAN}?from_city_code=42`,
  CURRENT_ROUTE_PLAN_MALATYA: `/${CURRENT_ROUTE_PLAN}?from_city_code=44`,
  CURRENT_ROUTE_PLAN_SAMSUN: `/${CURRENT_ROUTE_PLAN}?from_city_code=55`,
  CURRENT_ROUTE_PLAN_TRABZON: `/${CURRENT_ROUTE_PLAN}?from_city_code=61`,

  POINT_DISTRICTS: `/${POINT_DISTRICTS}`,

  CHAT_MESSAGES_LIST: `/${CHAT_MESSAGES_LIST}`,
  CHAT_MESSAGES_LIST_EDIT: (id: string | number) => `/${CHAT_MESSAGES_LIST}/${EDIT.replace(':id', String(id))}`,

  CONVERSATIONS: `/${CONVERSATIONS}`,
  CONVERSATIONS_DETAIL: (id: string | number) => `/${CONVERSATIONS}/${DETAIL.replace(':id', String(id))}`,

  CAREER_FORM: `/${CAREER_FORM}`,
  CAREER_FORM_DETAIL: (id: string | number) => `/${CAREER_FORM}/${DETAIL.replace(':id', String(id))}`,

  OPEN_POSITIONS: `/${OPEN_POSITIONS}`,
  OPEN_POSITIONS_DETAIL: (id: string | number) => `/${OPEN_POSITIONS}/${DETAIL.replace(':id', String(id))}`,
  OPEN_POSITIONS_EDIT: (id: string | number) => `/${OPEN_POSITIONS}/${EDIT.replace(':id', String(id))}`,
  DISTRIBUTION_EXPEDITIONS: `/${DISTRIBUTION_EXPEDITIONS}`,
  DISTRIBUTION_EXPEDITIONS_CREATE: `/${DISTRIBUTION_EXPEDITIONS}/create`,
  DISTRIBUTION_EXPEDITIONS_DETAIL: (id: string) => `/${DISTRIBUTION_EXPEDITIONS}/${id}`,
  DISTRIBUTION_EXPEDITIONS_EDIT: (id: string) => `/${DISTRIBUTION_EXPEDITIONS}/edit/${id}`,

  MOBILIZ_VEHICLE_DETAIL: `/${MOBILIZ_VEHICLE_DETAIL}`,
  MOBILIZ_FLEET: `/${MOBILIZ_FLEET}`,

  ETABLOLAR: `/${ETABLOLAR}`,

  DESKTOP_REPORT_USERS: `/${DESKTOP_REPORT_USERS}`,

  SAVED_REPORTS: `/${SAVED_REPORTS}`,

  NEIGHBOURHOODS: `/${NEIGHBOURHOODS}`,
  NEIGHBOURHOODS_EDIT: (id: string | number) => `/${NEIGHBOURHOODS}/${EDIT.replace(':id', String(id))}`,

  TICKETS: `/${TICKETS}`,
  TICKETS_DETAIL: (id: string | number) => `/${TICKETS}/${DETAIL.replace(':id', String(id))}`,
  TICKETS_EDIT: (id: string | number) => `/${TICKETS}/${EDIT.replace(':id', String(id))}`,
  TICKET_TEAMS: `/${TICKET_TEAMS}`,
  TICKET_TEAMS_DETAIL: (id: string | number) => `/${TICKET_TEAMS}/${DETAIL.replace(':id', String(id))}`,
  TICKET_TEAMS_EDIT: (id: string | number) => `/${TICKET_TEAMS}/${EDIT.replace(':id', String(id))}`,
  TICKET_STATISTICS: `/${TICKET_STATISTICS}`,

  FEEDBACK: `/${FEEDBACK}`,
  FEEDBACK_NEW: `/${FEEDBACK}/new`,
  FEEDBACK_DETAIL: (id: string | number) => `/${FEEDBACK}/${DETAIL.replace(':id', String(id))}`,
  FEEDBACK_ADMIN: `/${FEEDBACK_ADMIN}`,

  ACTIVITIES: `/${ACTIVITIES}`,
  BARCODE_ALERTS: `/${BARCODE_ALERTS}`,
  DEVICE_DIAGNOSTICS: `/${DEVICE_DIAGNOSTICS}`,
  REPLAY: `/${REPLAY}`,
  REPLAY_SETTINGS: `/${REPLAY}/settings`,
  REPLAY_DETAIL: (sessionId: string) => `/${REPLAY}/${encodeURIComponent(sessionId)}`,
  BARCODE_ALERTS_EDIT: (id: string | number) => `/${BARCODE_ALERTS}/${EDIT.replace(':id', String(id))}`,
  AGREEMENT_LOGS: `/${AGREEMENT_LOGS}`,
  COMPANY_LOGS: `/${COMPANY_LOGS}`,
  VENDOR_LOGS: `/${VENDOR_LOGS}`,
  POINT_LOGS: `/${POINT_LOGS}`,
  POINT_MAP_LOGS: `/${POINT_MAP_LOGS}`,
  POINT_MAP_ADMIN: `/${POINT_MAP_ADMIN}`,
  FLEET_DASHBOARD: `/${FLEET_DASHBOARD}`,
  FLEET_VEHICLES: `/${FLEET_VEHICLES}`,
  FLEET_VEHICLE_DETAIL: `/${FLEET_VEHICLE_DETAIL}`,
  FLEET_VEHICLE_EDIT: `/${FLEET_VEHICLE_EDIT}`,
  FLEET_DRIVERS: `/${FLEET_DRIVERS}`,
  FLEET_DRIVER_DETAIL: `/${FLEET_DRIVER_DETAIL}`,
  FLEET_ASSIGNMENTS: `/${FLEET_ASSIGNMENTS}`,
  FLEET_DOCUMENTS: `/${FLEET_DOCUMENTS}`,
  FLEET_AGENDA: `/${FLEET_AGENDA}`,
  FLEET_NOTIFICATIONS: `/${FLEET_NOTIFICATIONS}`,
  FLEET_MAP: `/${FLEET_MAP}`,
  FLEET_WORK_ORDERS: `/${FLEET_WORK_ORDERS}`,
  FLEET_WORK_ORDER_DETAIL: `/${FLEET_WORK_ORDER_DETAIL}`,
  FLEET_PLANS: `/${FLEET_PLANS}`,
  FLEET_TIRES: `/${FLEET_TIRES}`,
  FLEET_INSPECTIONS: `/${FLEET_INSPECTIONS}`,
  FLEET_POLICIES: `/${FLEET_POLICIES}`,
  FLEET_OFFERS: `/${FLEET_OFFERS}`,
  FLEET_DAMAGES: `/${FLEET_DAMAGES}`,
  FLEET_DAMAGE_DETAIL: `/${FLEET_DAMAGE_DETAIL}`,
  FLEET_TOLLS: `/${FLEET_TOLLS}`,
  FLEET_FINES: `/${FLEET_FINES}`,
  FLEET_EXPENSES: `/${FLEET_EXPENSES}`,
  FLEET_BUDGETS: `/${FLEET_BUDGETS}`,
  FLEET_TCO: `/${FLEET_TCO}`,
  FLEET_REPORTS: `/${FLEET_REPORTS}`,
  FLEET_SUPPLIERS: `/${FLEET_SUPPLIERS}`,
  FLEET_CONTRACTS: `/${FLEET_CONTRACTS}`,
  FLEET_TIMESHEET: `/${FLEET_TIMESHEET}`,
  FLEET_SCORING: `/${FLEET_SCORING}`,
  FLEET_SCORING_DETAIL: `/${FLEET_SCORING_DETAIL}`,
  FLEET_INDICATORS: `/${FLEET_INDICATORS}`,
  FLEET_SCHEMES: `/${FLEET_SCHEMES}`,
  FLEET_OPTION_SETS: `/${FLEET_OPTION_SETS}`,
  FLEET_CUSTOM_FIELDS: `/${FLEET_CUSTOM_FIELDS}`,
  FLEET_AUTOMATIONS: `/${FLEET_AUTOMATIONS}`,
  FLEET_REMINDER_SETTINGS: `/${FLEET_REMINDER_SETTINGS}`,
  FLEET_AUDIT: `/${FLEET_AUDIT}`,
  FLEET_CARRIER_REQUESTS: `/${FLEET_CARRIER_REQUESTS}`,
  FLEET_CARRIER_REQUEST_DETAIL: `/${FLEET_CARRIER_REQUEST_DETAIL}`,
  VEHICLE_LOGS: `/${VEHICLE_LOGS}`,
  ROUTE_LOGS: `/${ROUTE_LOGS}`,
  ROUTE_SESSION_LOGS: `/${ROUTE_SESSION_LOGS}`,
  TRANSFER_VEHICLE_ENTRY_LOGS: `/${TRANSFER_VEHICLE_ENTRY_LOGS}`,
  VEHICLE_PLAN_LOGS: `/${VEHICLE_PLAN_LOGS}`,
  USER_LOGS: `/${USER_LOGS}`,

  ZERO_DESI_UPDATE: `/${ZERO_DESI_UPDATE}`,
  OLUSTURULDU_ISLEMLERI: `/${OLUSTURULDU_ISLEMLERI}`,
  ZERO_DESI_LOGS: `/${ZERO_DESI_LOGS}`,
  ONE_DESI_REPORT: `/${ONE_DESI_REPORT}`,
  SCAN_ZERO_DESI: `/${SCAN_ZERO_DESI}`,
  COMPANY_DESI_RANGES: `/${COMPANY_DESI_RANGES}`,
  DOCUMENT_LOGS: `/${DOCUMENT_LOGS}`,

  MULTI_SESSION_USERS: `/${MULTI_SESSION_USERS}`,
  MULTI_SESSION_USERS_EDIT: (id: string | number) => `/${MULTI_SESSION_USERS}/${EDIT.replace(':id', String(id))}`,

  SESSION_INVALIDATION_LOGS: `/${SESSION_INVALIDATION_LOGS}`,

  AUDIT_LOGS: `/${AUDIT_LOGS}`,

  MCP_AUDIT: `/${MCP_AUDIT}`,
  OKUTMA_TESHIS: `/${OKUTMA_TESHIS}`,
  SANTRAL_API: `/${SANTRAL_API}`,
  INSURER_ACCESS: `/${INSURER_ACCESS}`,
  INSURER_ACCESS_GRANT: (id: string) => `/${INSURER_ACCESS}/${INSURER_ACCESS_GRANT.replace(':id', String(id))}`,
  INSURER_ACCESS_GRANT_DETAIL: (id: string) => `/${INSURER_ACCESS}/${INSURER_ACCESS_GRANT_DETAIL.replace(':id', String(id))}`,
  INSURERS: `/${INSURERS}`,
  INSURER_ACCESS_INSURER: (id: string) => `/${INSURERS}/${INSURER_ACCESS_INSURER.replace(':id', String(id))}`,
  DELIVERY_TIME_LOGS: `/${DELIVERY_TIME_LOGS}`,
  PRICE_ESTIMATE_LOGS: `/${PRICE_ESTIMATE_LOGS}`,

  ZAIMBOT: `/${ZAIMBOT}`,
  AGENTZAIM: `/${AGENTZAIM}`,

  SPECIAL_VEHICLE_SUGGESTIONS: `/${SPECIAL_VEHICLE_SUGGESTIONS}`,

  CUSTOMER_TRACKING: `/${CUSTOMER_TRACKING}`,
  CUSTOMER_TRACKING_DETAIL: (id: string | number) => `/${CUSTOMER_TRACKING}/${DETAIL.replace(':id', String(id))}`,
  CUSTOMER_TRACKING_ALERTS: `/${CUSTOMER_TRACKING_ALERTS}`,

  UNDELIVERED_PACKAGES: `/${UNDELIVERED_PACKAGES}`,
  UNDELIVERED_PACKAGES_LOGS: `/${UNDELIVERED_PACKAGES_LOGS}`,
  BULK_RECALC_ROUTE: `/${BULK_RECALC_ROUTE}`,
  BULK_CALC_PRICE: `/${BULK_CALC_PRICE}`,

  CHECKLIST: `/${CHECKLIST}`,
  CHECKLIST_TASKS: `/${CHECKLIST_TASKS}`,
  CHECKLIST_TASKS_EDIT: (id: string | number) => `/${CHECKLIST_TASKS}/${EDIT.replace(':id', String(id))}`,
  CHECKLIST_REPORT: `/${CHECKLIST_REPORT}`,

  UNIT_DESI_AVERAGES: `/${UNIT_DESI_AVERAGES}`,

  COMPANY_VEHICLE_VISITS: `/${COMPANY_VEHICLE_VISITS}`,

  LOW_VOLUME_COMPANIES: `/${LOW_VOLUME_COMPANIES}`,

  EXTERNAL_CARGO_TRACKING: `/${EXTERNAL_CARGO_TRACKING}`,

  LIVE_MONITOR: `/${LIVE_MONITOR}`,

  REMOTE_ACCESS: `/${REMOTE_ACCESS}`,
  REMOTE_ACCESS_SESSION: (id: string | number) => `/remote-access/session/${id}`,

  CARGO_IN_WAREHOUSE: `/${CARGO_IN_WAREHOUSE}`,
  CARGO_IN_WAREHOUSE_LOGS: `/${CARGO_IN_WAREHOUSE_LOGS}`,
  CARGO_IN_WAREHOUSE_LOGS_DETAIL: (id: string | number) => `/${CARGO_IN_WAREHOUSE_LOGS}/${DETAIL.replace(':id', String(id))}`,

  DIA_CARI_SYNC: `/${DIA_CARI_SYNC}`,
  DIA_SYNC_HISTORY: `/${DIA_SYNC_HISTORY}`,
  DIA_UNMATCHED: `/${DIA_UNMATCHED}`,
  DIA_CARI_KARTLAR: `/${DIA_CARI_KARTLAR}`,
  DIA_IRSALIYE_AKTAR: `/${DIA_IRSALIYE_AKTAR}`,
  DIA_IRSALIYE_AYARLAR: `/${DIA_IRSALIYE_AYARLAR}`,
  DIA_IRSALIYE_OLUSTUR: `/${DIA_IRSALIYE_OLUSTUR}`,

  FUEL: `/${FUEL}`,
  FUEL_STATIONS: `/${FUEL_STATIONS}`
};
